'use strict';
import angular from 'angular';
import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';
import html2pdf from 'html2pdf.js';

import modalIntegrationsCloneTemplateHtmlUrl from '../views/integrationsTemplates/modal_integrations_cloneTemplate.html';
import modalIntegrationsOrderTemplateHtmlUrl from '../views/integrationsTemplates/modal_integrations_orderTemplate.html';
import modalIntegrationsProductTemplateHtmlUrl from '../views/integrationsTemplates/modal_integrations_productTemplate.html';
import modalFromTemplateHtmlUrl from '../views/formTemplates/modal_fromTemplate.html';
import modalOrderTemplateHtmlUrl from '../views/formTemplates/modal_orderTemplate.html';
import modalProductTemplateHtmlUrl from '../views/formTemplates/modal_productTemplate.html';
import modalTaskTemplateHtmlUrl from '../views/formTemplates/modal_taskTemplate.html';
import modalWfFromTemplateHtmlUrl from '../views/wfTemplates/modal_wfFromTemplate.html';
import modalWfOrderTemplateHtmlUrl from '../views/wfTemplates/modal_wfOrderTemplate.html';
import modalWfProductTemplateHtmlUrl from '../views/wfTemplates/modal_wfProductTemplate.html';
import adUnitsRecTempHtmlUrl from '../views/adUnitsRecursiveTemp.html';


angular.module('modals.ctrls', [])

    .controller('ReassignTaskModalController', ReassignTaskModalController)
    .controller('AssignQueueModalController', AssignQueueModalController)
    .controller('ReassignModalController', ReassignModalController)
    .controller('SubmitUserModalController', SubmitUserModalController)
    .controller('AssignCampaignManagerModalController', AssignCampaignManagerModalController)
    .controller('TaskTimelogModalController', TaskTimelogModalController)
    .controller('CancelReasonModalController', CancelReasonModalController)
    .controller('ExceptionLogsModalController', ExceptionLogsModalController)
    .controller('CommonLogModalController', CommonLogModalController)
    .controller('IntegrationFormModalController', IntegrationFormModalController)
    .controller('SalesforceConnectionFormModalController', SalesforceConnectionFormModalController)
    .controller('AddMappingModalController', AddMappingModalController)
    .controller('DeleteMappingModalController', DeleteMappingModalController)
    .controller('InventoryEventsModalController', InventoryEventsModalController)
    .controller('InventoryReservedEventsModalController', InventoryReservedEventsModalController)
    .controller('NightlyStatusModalController', NightlyStatusModalController)
    .controller('NotificationsModalController', NotificationsModalController)
    .controller('ReportingModalController', ReportingModalController)
    .controller('UpdateHideConditionModalController', UpdateHideConditionModalController)
    .controller('AddFormLookupContentModalController', AddFormLookupContentModalController)
    .controller('CloneFormLookupContentModalController', CloneFormLookupContentModalController)
    .controller('DeleteLookupContentModalController', DeleteLookupContentModalController)
    .controller('CreateLookupContentModalController', CreateLookupContentModalController)
    .controller('CreateLookupTypeModalController', CreateLookupTypeModalController)
    .controller('DeleteCreativeModalController', DeleteCreativeModalController)
    .controller('DeletePixelModalController', DeletePixelModalController)
    .controller('LineItemChangesModalController', LineItemChangesModalController)
    .controller('FlightChangesModalController', FlightChangesModalController)
    .controller('MoveFlightModalController', MoveFlightModalController)
    .controller('AutoCreateFlightsModalController', AutoCreateFlightsModalController)
    .controller('ShowFormulaErrorsModalController', ShowFormulaErrorsModalController)
    .controller('RedistributeValuesModalController', RedistributeValuesModalController)
    .controller('CopyLineItemModalController', CopyLineItemModalController)
    .controller('AddRoutingRuleSetModalController', AddRoutingRuleSetModalController)
    .controller('AddRuleSetModalController', AddRuleSetModalController)
    .controller('AddRuleModalController', AddRuleModalController)
    .controller('CreateWorkflowModalController', CreateWorkflowModalController)
    .controller('ShowRuleSetModalController', ShowRuleSetModalController)
    .controller('CreateRoutingRuleModalController', CreateRoutingRuleModalController)
    .controller('CreateRoutingConditionModalController', CreateRoutingConditionModalController)
    .controller('CreateWorkflowTaskModalController', CreateWorkflowTaskModalController)
    .controller('CreateWorkflowTaskInterlockingModalController', CreateWorkflowTaskInterlockingModalController)
    .controller('AddWorkflowTaskModalController', AddWorkflowTaskModalController)
    .controller('CreateWorkflowActionModalController', CreateWorkflowActionModalController)
    .controller('CreateCustomStatusModalController', CreateCustomStatusModalController)
    .controller('CreateCancelReasonModalController', CreateCancelReasonModalController)
    .controller('CreateProductModalController', CreateProductModalController)
    .controller('CreateProductGroupModalController', CreateProductGroupModalController)
    .controller('CloneProductModalController', CloneProductModalController)
    .controller('CloneFormModalController', CloneFormModalController)
    .controller('AddProductContentModalController', AddProductContentModalController)
    .controller('UpdateProductsHideConditionModalController', UpdateProductsHideConditionModalController)
    .controller('LookupContentCloneModalController', LookupContentCloneModalController)
    .controller('LookupContentForClusterCloneModalController', LookupContentForClusterCloneModalController)
    .controller('CommentModalController', CommentModalController)
    .controller('OrderWatchersListModalController', OrderWatchersListModalController)
    .controller('AddCreativeLibraryModalController', AddCreativeLibraryModalController)
    .controller('CreativeToLineItemModalController', CreativeToLineItemModalController)
    .controller('PixelToLineItemModalController', PixelToLineItemModalController)
    .controller('AddCreativeModalController', AddCreativeModalController)
    .controller('FindIdsModalController', FindIdsModalController)
    .controller('ServiceMapperModalController', ServiceMapperModalController)
    .controller('DeleteIntegrationModalController', DeleteIntegrationModalController)
    .controller('CreateFormTemplateModalController', CreateFormTemplateModalController)
    .controller('CreateWfTemplateModalController', CreateWfTemplateModalController)
    .controller('CloneIntegrationTemplateModalController', CloneIntegrationTemplateModalController)
    .controller('AddWatcherModalController', AddWatcherModalController)
    .controller('CreateNewFromModalController', CreateNewFromModalController)
    .controller('ForceAddOrUpdateFormModalController', ForceAddOrUpdateFormModalController)
    .controller('ForceAddOrUpdateFormFieldModalController', ForceAddOrUpdateFormFieldModalController)
    .controller('PackageSetDefaultController', PackageSetDefaultController)
    .controller('LineItemStatusChangeController', LineItemStatusChangeController)
    .controller('AddCreativesFacebookModalController', AddCreativesFacebookModalController)
    .controller('UnprocessableEntityModalController', UnprocessableEntityModalController)
    .controller('HelperTextController', HelperTextController)
    .controller('GetBulkKeywordsController', GetBulkKeywordsController)
    .controller('AssignPlacementsController', AssignPlacementsController)

ReassignTaskModalController.$inject = ['$scope', '$modalInstance', 'data'];

function ReassignTaskModalController($scope, $modalInstance, data) {
    $scope.type = 'reassignTask';
    $scope.title = "Reassign Task";
    $scope.users = data.items;
    if (data.task.user_id) {
        for (var x = 0; x < $scope.users.length; x++) {
            var user = $scope.users[x];
            if (user.id == data.task.user_id) {
                $scope.selectedItem = user;
            }
        }
    }

    $scope.selectUser = function(user) {
        $scope.selectedItem = user;

        if ($scope.selectedItem == user) {
            $scope.enableAssignTask = true;
        }
    };

    $scope.ok = function() {
        $modalInstance.close($scope.selectedItem);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

AssignQueueModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AssignQueueModalController($scope, $modalInstance, data) {
    $scope.type = 'assignQueue';
    $scope.queues = data.items;

    $scope.ok = function() {
        $modalInstance.close($scope.selectedItem);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

ReassignModalController.$inject = ['$scope', '$modalInstance', 'data'];

function ReassignModalController($scope, $modalInstance, data) {
    $scope.type = 'reassign';
    $scope.title = "Reassign";
    $scope.users = data.items;
    $scope.enableAssignTask = false;
    $scope.sortReverse = false;
    $scope.sortType = 'in_out_status_id';

    $scope.selectUser = function(user) {
        $scope.selectedItem = user;

        if ($scope.selectedItem == user) {
            $scope.enableAssignTask = true;
        }
    };

    $scope.ok = function() {
        $modalInstance.close($scope.selectedItem);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

SubmitUserModalController.$inject = ['$scope', '$modalInstance', 'data'];

function SubmitUserModalController($scope, $modalInstance, data) {
    $scope.type = 'submitUser';
    $scope.title = "Submit User";
    $scope.users = data.items;

    $scope.ok = function() {
        $modalInstance.close($scope.selectedItem);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

AssignCampaignManagerModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AssignCampaignManagerModalController($scope, $modalInstance, data) {
    $scope.type = 'assignCampaignManager';
    if (data.lineItem === null) {
        $scope.title = "Bulk Assign Campaign Manager";
    } else {
        $scope.title = "Assign Campaign Manager";
    }
    $scope.users = data.items;
    if (data.selectedItem.id) {
        $scope.selectedItem = data.selectedItem;
    }
    $scope.lineItem = data.lineItem;
    $scope.unAssign = function(lineItem) {
        data.scope.showUnassignConfirm(lineItem);
        $modalInstance.dismiss('cancel');
    };
    $scope.bulkUnassign = function() {
        data.scope.showBulkUnassignConfirm();
        $modalInstance.dismiss('cancel');
    };
    $scope.ok = function() {
        $modalInstance.close($scope.selectedItem);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

LineItemStatusChangeController.$inject = ['$scope', '$modalInstance', 'data','OrdersService','$ioAlert'];

function LineItemStatusChangeController($scope, $modalInstance, data,OrdersService,$ioAlert) {
    $scope.type = 'bulkStatusChangeLineItems';
    $scope.bulkAction = data.action;
    $scope.selectedItems = data.selectedItems;
    $scope.orderId = data.scope.order.id;
    $scope.ok = function () {
        var reqData = {
            id: $scope.selectedItems,
            status: $scope.bulkAction,
            order_id: $scope.orderId
        }
        OrdersService.bulkLineItemStatus(reqData).then(function (response) {
            if(response && response.Result){
                if(response.Result.Success.length > 0){
                    _.each(data.scope.lineItems,function(item){
                            _.each(response.Result.Success,function(res){
                                if(item.id == res){
                                    item.status_name = response.Result.status;
                                }
                            });
                    });
                    data.scope.selectedLineItems =[];
                    $scope.selectedItems =[];
                    $ioAlert.show('Success',response.Result.Success.length +' '+"Line Items"+" "+response.Result.status+' '+'Successfully', 'success');
                } else{
                    $ioAlert.show(response.Result.status+' '+'failed',"No line item eligible for operation", 'success');
                    $scope.selectedItems = [];
                    data.scope.selectedLineItems =[];
                }
            }
        }, function () {
            $ioAlert.show('Error', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
        $modalInstance.close($scope.selectedItem);
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
}

TaskTimelogModalController.$inject = ['$scope', '$modalInstance', 'TaskService', 'data', '$ioAlert'];

function TaskTimelogModalController($scope, $modalInstance, TaskService, data, $ioAlert) {
    $scope.type = 'taskTimelog';
    $scope.title = "Task Time Log";

    $scope.taskAssignmentTimelog = data.items;

    $scope.delete = function(TlId, TId) {
        TaskService.deleteTimelogEntry(TlId, TId).then(function() {
            $scope.taskAssignmentTimelog = TaskService.Timelog;
            data.scope.taskAssignment = TaskService.taskAssignment;
            $ioAlert.show('', 'Deleted successfully', 'success');
        }, function() {
            $ioAlert.show('Error', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.ok = function() {
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

CancelReasonModalController.$inject = ['$scope', '$modalInstance', 'OrdersService', 'data'];

function CancelReasonModalController($scope, $modalInstance, OrdersService, data) {
    $scope.type = 'cancelReason';
    $scope.title = data.type + " Cancellation Reason";

    $scope.cancelReasons = data.items;
    $scope.cancelReasons = _.sortBy($scope.cancelReasons, ['name']);
    if (data.cancelReason) {
        $scope.cancelReason = data.cancelReason;
        $scope.cancelReasonText = data.cancelReasonText;
    }

    $scope.ok = function() {
        var cr = [];
        cr.id = $scope.cancelReason;
        cr.text = $scope.cancelReasonText;
        $modalInstance.close(cr);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

ExceptionLogsModalController.$inject = ['$scope', '$modalInstance', '$q', 'data'];

function ExceptionLogsModalController($scope, $modalInstance, $q, data) {
    $scope.type = 'exceptionLogs';
    $scope.tableReady = false;
    $scope.property = data.property;
    $scope.day = moment(data.day).format('MM/DD/YYYY');
    initDataTableOptions().then(function(dtOptions) {
        $scope.dtOptions = dtOptions;
        $scope.tableReady = true;
    });

    function cleanseData() {
        var returnData = [];
        data.exceptions.forEach(function(log) {
            log.data.control = '';
            returnData.push(log.data);
        });
        return returnData;
    }
    $scope.closeModal = function() {
        $modalInstance.dismiss();
    };

    function initDataTableOptions() {
        var deferred = $q.defer();
        var dtOptions = {};
        dtOptions.data = cleanseData();
        dtOptions.columns = [
            { field: 'id', label: 'Id' },
            { field: 'created_at', label: 'Created at' },
            { field: 'entry', format: 'custom', label: 'Entry', class: 'link-cell' }
        ];
        dtOptions.entityName = 'exceptions';
        dtOptions.itemName = 'exception';
        dtOptions.modal = true;
        dtOptions.hasFixedHeader = false;
        dtOptions.customRenders = {};
        dtOptions.customRenders['entry'] = function(data) {
            return '<a class="order-link">' + (data.length > 140 ? data.substring(0, 140) + '...' : data) + '</a>';
        };
        dtOptions.fnCreatedRow = function(row, raw) {
            $(row).find('a').each(function() {
                var $cell = $(this).closest('td');
                $cell.click(function() {
                    $scope.showEntry(raw);
                });
            });
            $.core.main.tooltip($(row));
        };
        deferred.resolve(dtOptions);
        return deferred.promise;
    }
    $scope.showEntry = function(raw) {
        $scope.viewEntry = true;
        $scope.entry = raw.entry;
    };
    $scope.closeEntry = function() {
        $scope.viewEntry = false;
        $scope.entry = null;
    }
}

CommonLogModalController.$inject = ['$scope', '$modalInstance', 'ExceptionLogsService', 'data', '$ioAlert'];

function CommonLogModalController($scope, $modalInstance, ExceptionLogsService, data, $ioAlert) {
    $scope.type = 'commonLog';
    $scope.title = data.title + ' #' + data.id;
    $scope.logEntry = 'Fetching data...';
    const logType = data.logType;
    const logId = data.id;


    function loadExceptionLog(id) {
        ExceptionLogsService.getExceptionLog(id).then(function(data) {
            if (data.exceptionLogEntry) {
                $scope.logEntry = data.exceptionLogEntry.entry;
            } else {
                $scope.logEntry = data.errors;
            }
        }, function(error) {
            $ioAlert.show('Error', error, 'error');
        });
    };


    function loadLogEntry() {
        switch (logType) {
            case 'exceptionLog':
                loadExceptionLog(logId);
                break;
            default:
                $scope.logEntry = 'Data Not Found';
        }
    };

    $scope.ok = function() {
        $modalInstance.close();
    };

    loadLogEntry();
}

// TODO: Moved to new controller, Remove after testing TO-688
SalesforceConnectionFormModalController.$inject = ['$scope', '$modalInstance', 'data', '$stateParams', 'ioServiceConnectionsService', '$ioAlert'];

function SalesforceConnectionFormModalController($scope, $modalInstance, data, $stateParams, ioServiceConnectionsService, $ioAlert) {
    $scope.type = 'salesforceConnectionForm';
    $scope.saleforceObj = {};
    $scope.saleforceObj.new = true;
    if (data && data.data && data.data.salesforceObj) {
        var userDataObj = JSON.parse(data.data.salesforceObj.user_data);
        $scope.saleforceObj.new = false;
        $scope.saleforceObj.name = data.data.salesforceObj.name;
        $scope.saleforceObj.id = data.data.salesforceObj.id;
        $scope.saleforceObj.clientToken = userDataObj.client_token;
        $scope.saleforceObj.clientTokenSecret = userDataObj.client_token_secret;
        $scope.saleforceObj.url = userDataObj.url;
        $scope.saleforceObj.user_name = userDataObj.user_name;
        $scope.saleforceObj.password = userDataObj.password;
        $scope.saleforceObj.security_token = userDataObj.security_token;
    }
    $scope.saveSalesforceConnection = function(integrationForm) {
        if (integrationForm.$valid) {
            var obj = {
                "serviceId": 1,
            };
            var userData = {
                "url": angular.lowercase($scope.saleforceObj.url),
                "user_name": $scope.saleforceObj.user_name,
                "password": $scope.saleforceObj.password,
                "client_token": $scope.saleforceObj.clientToken,
                "client_token_secret": $scope.saleforceObj.clientTokenSecret,
                "security_token": $scope.saleforceObj.security_token
            };
            obj.userData = JSON.stringify(userData);
            if ($scope.saleforceObj.new) {
                ioServiceConnectionsService.addServiceConnection(obj).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('Error', response.errors[i]);
                        }
                    } else if (response.serviceConnection) {
                        $ioAlert.show('', "Added Credentials Successfully", "success");
                        $modalInstance.close(response.serviceConnection);
                    } else {
                        $ioAlert.show('Error', "Error Adding Service Connection");
                    }

                }, function() {
                    console.log("Error Adding Service Connection");
                });
            } else {
                obj.id = $scope.saleforceObj.id;
                ioServiceConnectionsService.updateServiceConnection(obj).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('Error', response.errors[i]);
                        }
                    } else if (response.serviceConnection) {
                        $modalInstance.close(response.serviceConnection);
                        $ioAlert.show('', "Updated Credentials Successfully", 'success');
                    } else {
                        $ioAlert.show('Error', "Error Updating Service Connection");
                    }
                }, function() {
                    console.log("Error Update Service Connection");
                });
            }
        } else {
            $ioAlert.show('Error', "Please fill the required fields");
        }
    };
    $scope.testSalesforceConnection = function(integrationForm) {
        if (integrationForm.$valid) {
            $modalInstance.close($scope.saleforceObj);
        }
    };
    $scope.cancelSalesforce = function() {
        $modalInstance.dismiss();
    }
}

IntegrationFormModalController.$inject = ['$scope', '$modalInstance', 'data', 'IntegrationsService', '$ioAlert'];

function IntegrationFormModalController($scope, $modalInstance, data, IntegrationsService, $ioAlert) {
    $scope.type = 'integrationForm';
    $scope.new = true;
    $scope.isDisabled = false;
    $scope.typeId = '1';
    $scope.isSalesforceModel = false;
    $scope.isWebhookModel = false;
    $scope.showClientOnlyCb = false;
    $scope.salesObj = {};
    $scope.webhookObj = { typeId: '4' };
    $scope.webhookTypes = [{ id: 4, label: "Publish" }, { id: 5, label: "Consume" }];
    $scope.integrationHeader = "Create new Integration";
    if (data && data.data) {
        if (data.data.type_id && data.data.type_id != "0") {
            $scope.typeId = data.data.type_id;
        }
        if ($scope.typeId == "3") {
            $scope.isSalesforceModel = true;
        } else if ($scope.typeId == "2") {
            $scope.showClientOnlyCb = true;
        } else if ($scope.typeId == "4" || $scope.typeId == "5") {
            $scope.isWebhookModel = true;
            $scope.webhookObj.typeId = $scope.typeId;
        }
        if (data.data.id) {
            $scope.new = false;
            $scope.integrationHeader = "Update Integration";
            $scope.name = data.data.name;
            $scope.id = data.data.id;
            $scope.salesObj.clientOnly = (parseInt(data.data.client_only) == 1) ? true : false;
            if ($scope.typeId == '4' || $scope.typeId == '5') {
                getWebhookSub();
            }
        }
        $scope.webhookObj.typeId = parseInt($scope.typeId);
    }

    function getWebhookSub() {
        IntegrationsService.getWebhookForIntegration({ 'integrationId': $scope.id }).then(function(data) {
            if (data && data.id && data.additional_info) {
                $scope.webhookObj.id = data.id;
                $scope.webhookObj.name = data.name;
                $scope.webhookObj.url = data.additional_info.url;
                $scope.webhookObj.methodType = data.additional_info.method_type;
                $scope.webhookObj.authType = data.additional_info.type;
                $scope.webhookObj.authInfo = data.additional_info.auth_info;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.addOrUpdateIntegration = function(integrationForm) {
        if (integrationForm.$valid) {
            if ($scope.isWebhookModel) {
                $scope.typeId = $scope.webhookObj.typeId;
            }
            if ($scope.isSalesforceModel) {
                var clientOnly = ($scope.salesObj.clientOnly === true) ? 1 : 0;
                $modalInstance.close($scope.new ? { name: $scope.name, new: $scope.new, typeId: $scope.typeId, clientOnly: clientOnly } : { id: $scope.id, name: $scope.name, typeId: $scope.typeId, serviceConnectionId: data.data.service_connection_id, clientOnly: clientOnly });
            } else if ($scope.showClientOnlyCb) {
                var clientOnly = ($scope.salesObj.clientOnly === true) ? 1 : 0;
                $modalInstance.close($scope.new ? { name: $scope.name, new: $scope.new, typeId: $scope.typeId, clientOnly: clientOnly } : { id: $scope.id, name: $scope.name, typeId: $scope.typeId, serviceConnectionId: data.data.service_connection_id, clientOnly: clientOnly, webhookObj: $scope.webhookObj });
            } else {
                $modalInstance.close($scope.new ? { name: $scope.name, new: $scope.new, typeId: $scope.typeId } : { id: $scope.id, name: $scope.name, typeId: $scope.typeId, serviceConnectionId: data.data.service_connection_id, webhookObj: $scope.webhookObj });
            }
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    }
}

AddMappingModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClusterService', 'ProductService', '$ioAlert'];

function AddMappingModalController($scope, $modalInstance, data, ClusterService, ProductService, $ioAlert) {
    $scope.type = 'addMapping';
    $scope.clusters = [];
    $scope.products = [];
    $scope.mappingObj = {};
    $scope.mappingObj.new = true;
    $scope.isClientType = false;
    $scope.nonIOUser = data.nonIOUser;

    function editData() {
        $scope.mappingObj.new = false;
        $scope.mappingObj.id = data.mapping.id;
        $scope.mappingObj.integrationTypeId = data.mapping.type_id;
        $scope.mappingObj.xrefValue = data.mapping.xref_value;
        $scope.mappingObj.xrefKey = data.mapping.xref_key;
        $scope.mappingObj.isDefault = (data.mapping.is_default == 1);
        $scope.pickMapping(data.mapping.type_id);
    }


    /*
     * Deleting Client if already exist
     */
    if (data.hasClient) {
        var keyN;
        _.forEach(data.xrefTypes, function(type, key) {
            if (type == 'Client') {
                keyN = key;
            }
        });
        delete data.xrefTypes[keyN];
    }


    $scope.mappingTypes = _.omitBy(data.xrefTypes, function(value) {
        return !value;
    });
    if ($scope.nonIOUser === true) {
        if (data.hasClient) {
            $scope.mappingTypes = [];
        } else {
            var tempMappingTypes = $scope.mappingTypes;
            _.each(tempMappingTypes, function(item, itemIndex) {
                if (item == 'client' || item == 'Client') {
                    $scope.mappingTypes = [];
                    $scope.mappingTypes[itemIndex] = item;
                    return false;
                }
            });
        }

    }

    $scope.integration = data.integration;
    $scope.mappingObj.integrationId = $scope.integration.id;
    $scope.xrefArr = [];

    $scope.addMapping = function(mappingForm, isClient) {
        //If the type is client we dont need to validate the form
        if (isClient) {
            $modalInstance.close($scope.mappingObj);
        } else if (mappingForm.$valid) {
            $modalInstance.close($scope.mappingObj);
        } else {

        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.pickMapping = function(mapping) {
        $scope.xrefArr = [];
        if (mapping) {
            if (mapping == 1) {
                $scope.xrefArr = $scope.products;
            } else if (mapping == 2) {
                $scope.xrefArr = $scope.clusters;
            } else if (mapping == 3) {
                $scope.isClientType = true;
            }
        }

    };

    $scope.getClusters = function() {
        $scope.clusters = ClusterService.clusters;

    };

    $scope.getProducts = function() {
        $scope.isLoading = true;
        ProductService.getAllProducts('no').then(function() {
            $scope.products = ProductService.products;
            $scope.isLoading = false;
            if (data && data.mapping) {
                editData();
            }
        }, function() {
            $scope.isLoading = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var init = function() {
        $scope.getProducts();
        $scope.getClusters();
    };
    init();
}

DeleteMappingModalController.$inject = ['$scope', '$modalInstance', 'data'];

function DeleteMappingModalController($scope, $modalInstance) {
    $scope.type = 'deleteMapping';
    $scope.deleteMapping = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    }
}

DeleteIntegrationModalController.$inject = ['$scope', '$modalInstance', 'data'];

function DeleteIntegrationModalController($scope, $modalInstance) {
    $scope.type = 'deleteIntegration';
    $scope.deleteMapping = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    }
}

InventoryEventsModalController.$inject = ['$scope', '$modalInstance', '$q', 'data'];

function InventoryEventsModalController($scope, $modalInstance, $q, data) {
    $scope.type = 'inventoryEvents';
    $scope.tableReady = false;
    $scope.property = data.property;
    $scope.day = moment(data.day).format('MM/DD/YYYY');
    initDataTableOptions().then(function(dtOptions) {
        $scope.dtOptions = dtOptions;
        $scope.tableReady = true;
    });

    function cleanseData() {
        var returnData = [];
        data.inventory.forEach(function(inventoryItem) {
            inventoryItem.control = '';
            returnData.push(inventoryItem);
        });
        return returnData;
    }
    $scope.closeModal = function() {
        $modalInstance.dismiss();
    };

    function initDataTableOptions() {
        var deferred = $q.defer();
        var dtOptions = {};
        dtOptions.data = cleanseData();
        dtOptions.columns = [

            { field: 'line_item_id', format: 'custom', label: 'Line Item', className: 'link-cell' },
            { field: 'name', label: 'Type' },
            { field: 'client_name', label: 'Client' },
            { field: 'order_id', label: 'Order Id' },
            { field: 'line_item_start_date', label: 'Start Date' },
            { field: 'line_item_end_date', label: 'End Date' },
            { field: 'line_item_status', label: 'Status' },
            { field: 'total_budget', label: 'Total Budget' },
            { field: 'salesperson_name', label: 'Sales Rep' },
            { field: 'website', label: 'Site Placement' },
            { field: 'section', label: 'Section' },
            { field: 'ad_size', label: 'Ad Size' }

        ];
        dtOptions.entityName = 'line items';
        dtOptions.itemName = 'line item';
        dtOptions.modal = true;
        dtOptions.hasFixedHeader = false;
        dtOptions.customRenders = {};
        dtOptions.customRenders['line_item_id'] = function(data) {
            return '<a class="order-link" href="#/items/viewLineItem/' + data + '">' + data + '</a>';
        };
        dtOptions.fnCreatedRow = function(row, raw, id) {
            $(row).find('a').each(function() {
                var $cell = $(this).closest('td');
                if ($cell.hasClass('link-cell')) {
                    $cell.click(function() {
                        $scope.open(id);
                    });
                }
            });
            $.core.main.tooltip($(row));
        };
        deferred.resolve(dtOptions);
        return deferred.promise;
    }
    $scope.open = function() {
        $modalInstance.dismiss();
    }
}

InventoryReservedEventsModalController.$inject = ['$scope', '$modalInstance', '$q', 'data', 'InventoryCalendarService', '$ioAlert'];

function InventoryReservedEventsModalController($scope, $modalInstance, $q, data, InventoryCalendarService, $ioAlert) {
    $scope.type = 'inventoryReservedEvents';
    $scope.tableReady = false;
    $scope.property = data.property;
    $scope.day = moment(data.day).format('MM/DD/YYYY');
    initDataTableOptions().then(function(dtOptions) {
        $scope.dtOptions = dtOptions;
        $scope.tableReady = true;
    });

    function cleanseData() {
        var returnData = [];
        data.inventory.forEach(function(inventoryItem) {
            inventoryItem.control = '';
            returnData.push(inventoryItem);
        });
        return returnData;
    }
    $scope.closeModal = function() {
        $modalInstance.dismiss();
    };
    $scope.delSlotReservation = function(raw) {
        InventoryCalendarService.deleteSlotReservation(raw.slot_id, raw.reservation_date).then(function(response) {
            if (response.errors) {
                $ioAlert.show('Error!', response.errors[0], 'error');
            } else {
                $ioAlert.show('', 'Slot unreserved successfully', 'success');
                response.website_id = raw.website_id;
                response.calendar_date = data.day;
                $modalInstance.close(response);
            }
        });
    };

    function initDataTableOptions() {
        var deferred = $q.defer();
        var dtOptions = {};
        dtOptions.data = cleanseData();
        dtOptions.columns = [
            { field: 'name', label: 'Ad Slot' },
            { field: 'reservation_date', label: 'Reservation Date' },
            { field: 'reserver_name', label: 'Reserved by' },
            { field: 'website', label: 'Site Placement' },
            { field: 'section', label: 'Section' },
            { field: 'client_id', label: 'Client Id' },
            { field: 'client_name', label: 'Client Name' },
            { field: 'slot_reservation', format: 'custom', label: 'Actions', class: 'link-slot' }
        ];
        dtOptions.entityName = 'line items';
        dtOptions.itemName = 'line item';
        dtOptions.modal = true;
        dtOptions.hasFixedHeader = false;
        dtOptions.customRenders = {};
        dtOptions.customRenders['slot_reservation'] = function() {
            return '<a class="link-slot-delete has-tooltip" title="" data-original-title="Delete Slot Reservation"> <span class="icon icon-minus-circle"></span> </a>';
        };
        dtOptions.fnCreatedRow = function(row, raw) {
            $(row).find('a').each(function() {
                $(this).click(function() {
                    $scope.delSlotReservation(raw);
                });
            });
            $.core.main.tooltip($(row));
        };
        deferred.resolve(dtOptions);
        return deferred.promise;
    }
    $scope.open = function() {
        $modalInstance.dismiss();
    }
}

NightlyStatusModalController.$inject = ['$scope', '$modalInstance', 'NightlyStatusService', '$timeout', '$q', 'data'];

function NightlyStatusModalController($scope, $modalInstance, NightlyStatusService, $timeout, $q, data) {
    $scope.type = 'nightlyStatus';
    $scope.tableReady = false;
    $scope.property = data.property;
    $scope.day = moment(data.events[0].startsAt).format('MM/DD/YYYY');
    $scope.loadingMessage = 'loading data...';

    initDataTableOptions().then(function(dtOptions) {
        $scope.dtOptions = dtOptions;
        const date_string = data.events[0].data.date_string;
        NightlyStatusService.logsForDay(date_string).then(function(logs){
            $scope.loadingMessage = 'preparing table...'
            $timeout(function() {
                $scope.dtOptions.data = genCalItems(logs);
                $scope.tableReady = true;
            });
        });
    });

    function genCalItems(logs) {
        return $.map(logs, function(log) {
            let table_row_id_link = log.table_row_id;
            
            switch (log.table_name) {
                case "order":
                    table_row_id_link = '<a href="#/items/viewOrder/'+log.table_row_id+'" target="_blank">'+log.table_row_id+'</a>';
                    break;
                case "line_item":
                    table_row_id_link = '<a href="#/items/viewLineItem/'+log.table_row_id+'" target="_blank">'+log.table_row_id+'</a>';
                    break;
                case "flight":
                    table_row_id_link = '<a href="#/items/viewFlight/'+log.table_row_id+'" target="_blank">'+log.table_row_id+'</a>';
                    break;
            }

            return {
                    success: log.success,
                    id: log.id,
                    job_name: log.job_name,
                    message: log.message,
                    table_name: log.table_name,
                    table_row_id: table_row_id_link,
                    control: '',
            }
        })
    }

    $scope.closeModal = function() {
        $modalInstance.dismiss();
    };

    function initDataTableOptions() {
        var deferred = $q.defer();
        var dtOptions = {};
        dtOptions.data = {};
        dtOptions.columns = [
            { field: 'success', format: 'custom', label: 'Status' },
            { field: 'id', label: 'Job Log Id' },
            { field: 'job_name', label: 'Job Name' },
            { field: 'message', label: 'Job Message' },
            { field: 'table_name', label: 'Job Target' },
            { field: 'table_row_id', label: 'Job Target Id' }
        ];
        dtOptions.entityName = 'jobs';
        dtOptions.itemName = 'job';
        dtOptions.modal = true;
        dtOptions.hasFixedHeader = false;
        dtOptions.customRenders = {};
        dtOptions.customRenders['success'] = function(data) {
            return '<div style="border-radius: 50%; width: 15px; height: 15px; background-color: ' + (data === "1" ? 'green' : 'red') + ';"></div>'
        };
        deferred.resolve(dtOptions);
        return deferred.promise;
    }
}

NotificationsModalController.$inject = ['$scope', '$modalInstance', 'data', 'OrdersService', 'TaskService', '$rootScope', '$sanitize'];

function NotificationsModalController($scope, $modalInstance, data, OrdersService, TaskService, $rs, $sanitize) {
    $scope.type = 'notifications';
    var NOTIFICATION_OBJECT_TYPE_ORDER = 1;
    var NOTIFICATION_OBJECT_TYPE_LINE_ITEM = 2;
    var NOTIFICATION_OBJECT_TYPE_TASK = 3;
    var NOTIFICATION_OBJECT_TYPE_COMMENT = 4;

    $scope.notification = data;
    $scope.archived = data.archived;
    $scope.additionalInfoOne = '';
    $scope.additionalInfoTwo = '';
    $scope.additionalInfoThree = '';
    $scope.additionalInfoFour = '';
    $scope.additionalInfoFive = '';
    $scope.additionalInfoSix = '';
    $scope.isTask = false;
    $scope.loadingMessage = true;

    if ($rs.userRole && ($rs.userRole.permissions == 'vendor' || $rs.userRole.permissions == 'vendor-restricted')) {
        $scope.isViewDisabled = true;
    } else {
        $scope.isViewDisabled = false;
    }

    $scope.archive = function() {
        $modalInstance.close('archive');
    };

    $scope.open = function() {
        $modalInstance.close('open');
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    var getOrder = function(orderId, isTask) {
        OrdersService.getOrder(orderId).then(function() {
            var order = OrdersService.order;
            if (order && !isTask) {
                if (order.salesperson_id[1]) {
                    $scope.additionalInfoOne = '<b>Salesperson: </b>' + $sanitize(order.salesperson_id[1]);
                } else {
                    $scope.additionalInfoOne = '<b>Salesperson: </b>';
                }
                $scope.additionalInfoTwo = '<b>Client: </b>' + $sanitize(order.client_id[1]);
            } else if (order) {
                if (order.salesperson_id[1]) {
                    $scope.additionalInfoThree = '<b>Salesperson: </b>' + $sanitize(order.salesperson_id[1]);
                } else {
                    $scope.additionalInfoThree = '<b>Salesperson: </b>';
                }
                $scope.additionalInfoFour = '<b>Order Number:</b> ' + $sanitize(String(order.id));
                $scope.additionalInfoFive = '<b>Client: </b>' + $sanitize(order.client_id[1]);
                $scope.additionalInfoSix = '<b>Status: </b>' + $sanitize(order.status_id[1]);
            }
            $scope.loadingMessage = false;
        });
    };

    var getLineItem = function(lineItemId, isTask) {
        OrdersService.getLineItem(lineItemId).then(function() {
            var lineItem = OrdersService.lineItem;

            if (lineItem && !isTask) {
                $scope.additionalInfoOne = '<b>Order Number: </b>' + $sanitize(String(lineItem.order_id));
                $scope.additionalInfoTwo = '<b>Product: </b>' + $sanitize(lineItem.product_name);
                $scope.additionalInfoThree = '<b>Campaign: </b>' + $sanitize(lineItem.campaign_name);
            } else {
                $scope.additionalInfoFour = '<b>Order Number:</b> ' + $sanitize(String(lineItem.order_id));
                $scope.additionalInfoFive = '<b>Product: </b>' + $sanitize(lineItem.product_name);
                $scope.additionalInfoSix = '<b>Status: </b>' + $sanitize(lineItem.status_name);
            }

            $scope.loadingMessage = false;
        });
    };

    var getTaskAssignment = function() {
        TaskService.getTaskAssignment($scope.notification.object_id).then(function() {
            var taskAssignment = TaskService.taskAssignment;
            if (taskAssignment) {
                if (taskAssignment.line_item_id) {
                    getLineItem(taskAssignment.line_item_id, true);
                } else if (taskAssignment.order_id) {
                    getOrder(taskAssignment.order_id, true);

                }
                $scope.additionalInfoOne = '<b>Description: </b>' + $sanitize(taskAssignment.description);
                $scope.additionalInfoTwo = '<b>Client: </b>' + $sanitize(taskAssignment.client_name);
            }
        });
    };

    var formatComment = function() {
        $scope.loadingMessage = false;
        $scope.additionalInfoOne = $sanitize($scope.notification.comment);
        if ($scope.notification.table_name == "order") {

        } else if ($scope.notification.table_name == "line_item") {
            $scope.isTask = true;
        }
    };

    var init = function() {
        if ($scope.notification.object_type_id == NOTIFICATION_OBJECT_TYPE_ORDER) {
            getOrder($scope.notification.object_id, false);
        } else if ($scope.notification.object_type_id == NOTIFICATION_OBJECT_TYPE_LINE_ITEM) {
            getLineItem($scope.notification.object_id, false);
        } else if ($scope.notification.object_type_id == NOTIFICATION_OBJECT_TYPE_TASK) {
            $scope.isTask = true;
            getTaskAssignment();
        } else if ($scope.notification.object_type_id == NOTIFICATION_OBJECT_TYPE_COMMENT) {
            formatComment();
        }
    };

    init();
}

ReportingModalController.$inject = ['$scope', '$modalInstance', 'data'];

function ReportingModalController($scope, $modalInstance, data) {
    $scope.type = 'reporting';
    $scope.templateObj = {
        "name": data
    };
    $scope.addTemplate = function(templateForm) {
        if (templateForm.$valid) {
            if ($scope.templateObj)
                $modalInstance.close($scope.templateObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    }
}

UpdateHideConditionModalController.$inject = ['$scope', '$modalInstance', 'data'];

function UpdateHideConditionModalController($scope, $modalInstance, data) {
    $scope.type = 'updateHideConditionForm';
    $scope.headerTitle = "Update Hide Condition";
    $scope.conditionObj = {};
    var group = data.group;
    $scope.group = data.group;
    $scope.conditionObj.hideConditionTypes = data.hideConditionTypes;
    $scope.orderTypes = data.orderTypes;
    _.each($scope.orderTypes, function(type) {
        type.id = parseInt(type.id);
    });
    $scope.roleTypes = data.roleTypes;
    $scope.conditionObj.id = group.id;
    $scope.conditionObj.groupName = group.group_name;
    $scope.conditionObj.active = (group.active === true || group.active == '1');
    $scope.conditionObj.groupDisplayOrder = parseInt(group.group_display_order);
    $scope.conditionObj.hideForConditionType = group.hideForConditionType;
    $scope.conditionObj.hideForConditionValue = group.hideForConditionValue;
    if (group.hide_for_condition) {
        $scope.conditionObj.hideForCondition = group.selectedHideCondition.map(function (group) {
            return group.id;
        });
    }

    switch (group.hideForConditionType) {
        case "Order Type":
            $scope.conditionObj.hideConditionValues = data.orderTypes;
            break;
        case "Role Type":
            $scope.conditionObj.hideConditionValues = data.roleTypes;
            break;
    }
    $scope.selectCondtionType = function() {
        $scope.conditionObj.hideForCondition = undefined;
        switch ($scope.conditionObj.hideForConditionType) {
            case 'Order Type':
                $scope.conditionObj.hideConditionValues = $scope.orderTypes;
                break;
            case 'Role Type':
                $scope.conditionObj.hideConditionValues = $scope.roleTypes;
                break;
            default:
                $scope.conditionObj.hideConditionValues = undefined;
        }
    };

    $scope.clearHideCondition = function() {
        $scope.conditionObj.hideForConditionType = undefined;
        $scope.conditionObj.hideForCondition = undefined;
        $scope.conditionObj.hideConditionValues = undefined;
    };


    $scope.addHideCondition = function(groupForm) {
        if (groupForm.$valid) {
            $scope.conditionObj.id = group.id;
            $modalInstance.close($scope.conditionObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

AddFormLookupContentModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddFormLookupContentModalController($scope, $modalInstance, data) {
    $scope.type = 'addFormLookupContent';
    $scope.formContentObj = {
        "formId": data.formId
    };
    var formContent = data.formContent;

    $scope.lookupAttributes = data.lookupAttributes;
    if (formContent) {
        $scope.formContentObj.lookupContents = [];

        for (var i = 0; i < formContent.length; i++) {
            for (var j = 0, size = $scope.lookupAttributes.length; j < size; j++) {
                if ($scope.lookupAttributes[j].id == formContent[i].id) {
                    $scope.formContentObj.lookupContents.push($scope.lookupAttributes[j]);
                }
            }
        }
    }

    $scope.addFormContent = function(lookupContentForm) {
        if (lookupContentForm.$valid) {
            $modalInstance.close($scope.formContentObj);
        }
    };

    $scope.selectAllContents = function() {
        $scope.formContentObj.lookupContents = [];
        for (var j = 0, size = $scope.lookupAttributes.length; j < size; j++) {
            $scope.formContentObj.lookupContents.push($scope.lookupAttributes[j]);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CloneFormLookupContentModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClusterService', '$ioAlert', 'TaskService'];

function CloneFormLookupContentModalController($scope, $modalInstance, data, ClusterService, $ioAlert, TaskService) {
    $scope.type = 'cloneFormLookupContent';
    $scope.clusterArr = data.clusters;
    $scope.contentTypes = data.formContentTypes;
    $scope.formList = data.formList;
    $scope.cloneObj = {};
    const currentClusterId = ClusterService.clusterIds[0];
    const currentFormId = data.formId;

    $scope.selectAllClusters = function() {
        $scope.cloneObj.destClusterIds = [];
        _.each($scope.clusterArr, function(cluster){
            if (cluster.id != currentClusterId) {
                $scope.cloneObj.destClusterIds.push(cluster.id);
            }
        });
    };

    $scope.selectAllContentTypes = function() {
        $scope.cloneObj.lookupTypeIds = [];
        _.each($scope.contentTypes, function(contentType){
            $scope.cloneObj.lookupTypeIds.push(contentType.id);
        });
    };

    $scope.selectAllForms = function() {
        $scope.cloneObj.destFormIds = [];
        _.each($scope.formList, function(form){
            if (form.id != currentFormId) {
                $scope.cloneObj.destFormIds.push(form.id);
            }
        });
    };



    $scope.cloneContent = function(cloneForm) {
        // Note that we don't check whether or not the source and destination forms are different,
        // since we might want to copy form lookup content from one BU to another for an order form spanning
        // multiple BU.  However we are preventing copying to the same BU, as it would be a pain to handle collisions
        // in the backend.  Might be a future enhancement if required.
        if (!($scope.cloneObj.destClusterIds && $scope.cloneObj.destClusterIds.length)) {
            $ioAlert.show('', 'You must select a destination business unit.', 'error');
        } else if (!($scope.cloneObj.lookupTypeIds && $scope.cloneObj.lookupTypeIds.length)) {
            $ioAlert.show('', 'You must select content type to clone.', 'error');
        } else if (!($scope.cloneObj.destFormIds && $scope.cloneObj.destFormIds.length)) {
            $ioAlert.show('', 'You must select a destination form.', 'error');
        } else if ($scope.cloneObj.destClusterIds.indexOf(currentClusterId) > -1 &&
            $scope.cloneObj.destFormIds.indexOf(currentFormId) > -1
        ) {
            const message = 'The source Business Unit and the source form cannot be selected at the same time as the destination.'
            $ioAlert.show('', message, 'error');
        } else if (cloneForm.$valid) {
            if($scope.cloneObj.destFormIds[0] == null || $scope.cloneObj.destClusterIds[0] == null ||
                $scope.cloneObj.lookupTypeIds[0] == null) {
                $ioAlert.show('', 'Please provide the valid data', 'error');
            } else {
                $modalInstance.close($scope.cloneObj);
            }
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

DeleteLookupContentModalController.$inject = ['$scope', '$modalInstance', 'data'];

function DeleteLookupContentModalController($scope, $modalInstance, data) {
    $scope.type = 'deleteLookupContent';
    $scope.delete = function() {
        $modalInstance.close(data.lookupContentId);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateLookupContentModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateLookupContentModalController($scope, $modalInstance, data) {
    $scope.type = 'createLookupContent';
    $scope.lookupObj = {};
    var lookupContent = data.lookupContent;
    $scope.lookupObj.parentContentKeySourceNames = data.parentContentKeySourceNames;
    if (lookupContent) {
        $scope.lookupObj.lookupValue = lookupContent.lookup_value;
        $scope.lookupObj.id = lookupContent.id;
        $scope.lookupObj.parent_content_key_source_name = lookupContent.parent_content_key_source_name;
        $scope.lookupText = "Update";
    } else {
        $scope.lookupText = "Create New";
    }
    $scope.addLookupContent = function(lookupContentForm) {
        if (lookupContentForm.$valid) {
            $modalInstance.close($scope.lookupObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateLookupTypeModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateLookupTypeModalController($scope, $modalInstance, data) {
    $scope.type = 'createLookupType';
    $scope.lookupObj = {};
    $scope.lookupContentKeys = data.lookupContentKeys;
    $scope.lookupTypeIdNames = data.lookupTypeIdNames;
    var lookupType = data.lookupType;
    if (lookupType) {
        $scope.lookupObj.name = lookupType.name;
        $scope.lookupObj.id = lookupType.id;
        $scope.lookupObj.content_key = lookupType.content_key;
        $scope.lookupObj.parent_lookup_type_name = data.parentLookupTypeName;
        $scope.lookupText = "Update";
    } else {
        $scope.lookupText = "Create New";
    }
    $scope.addLookupType = function(lookupTypeForm) {
        if (lookupTypeForm.$valid) {
            $modalInstance.close($scope.lookupObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

DeleteCreativeModalController.$inject = ['$scope', '$modalInstance', 'data'];

function DeleteCreativeModalController($scope, $modalInstance, data) {
    $scope.type = 'deleteCreative';
    $scope.filename = data.filename;
    $scope.confirm = function () {
        $modalInstance.close('ok');
    };
    $scope.cancel = function () {
        $modalInstance.dismiss();
    };
}

// Modal Controller for Deleting(Disassociating) the Pixel from the Lineitem
DeletePixelModalController.$inject = ['$scope', '$modalInstance', 'data'];

function DeletePixelModalController($scope, $modalInstance, data) {
    $scope.type = 'deletePixel';
    $scope.pixelname = data.pixelname;
    $scope.confirm = function () {
        $modalInstance.close('ok');
    };
    $scope.cancel = function () {
        $modalInstance.dismiss();
    };
}

LineItemChangesModalController.$inject = ['$scope', '$modalInstance', 'data'];

function LineItemChangesModalController($scope, $modalInstance, data) {
    $scope.type = 'lineItemChanges';
    $scope.changesList = data.list;

    let isHTML = function(str) {
        return !_.isArray(str) && /<[a-z][a-z0-9]*\b[^>]*>/i.test(str);
    }

    let formatEntry = function(entry) {
        if (_.isArray(entry)) {
            if (_.isArray(entry[0])) {
                let output = "";
                _.each(entry, function(subentry) { output = output + subentry[1] + ", "; });
                return output.replace(/([,\s]+$)/g, '');
            } else {
                return entry[1];
            }
        } else {
            return entry;
        }
    };

    _.each($scope.changesList, function(entry) {
        if (entry.before) {
            if (isHTML(entry.before)) {
                entry.beforeIsHtml = true;
            } else {
                entry.before = formatEntry(entry.before);
                entry.beforeIsHtml = false;
            }
        }
        if (entry.after) {
            if (isHTML(entry.after)) {
                entry.afterIsHtml = true;
            } else {
                entry.after = formatEntry(entry.after);
                entry.afterIsHtml = false;
            }
        }
    });

    $scope.ok = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

FlightChangesModalController.$inject = ['$scope', '$modalInstance', 'data'];

function FlightChangesModalController($scope, $modalInstance, data) {
    $scope.type = 'flightChanges';
    $scope.changesList = data.list;

    let isHTML = function(str) {
        return !_.isArray(str) && /<[a-z][a-z0-9]*\b[^>]*>/i.test(str);
    }


    let formatEntry = function(entry) {
        if (_.isArray(entry)) {
            if (_.isArray(entry[0])) {
                let output = "";
                _.each(entry, function(subentry) { output = output + subentry[1] + ", "; });
                return output.replace(/([,\s]+$)/g, '');
            } else {
                return entry[1];
            }
        } else {
            return entry;
        }
    };

    _.each($scope.changesList, function(entry) {
        if (entry.before) {
            if (isHTML(entry.before)) {
                entry.beforeIsHtml = true;
            } else {
                entry.before = formatEntry(entry.before);
                entry.beforeIsHtml = false;
            }
        }
        if (entry.after) {
            if (isHTML(entry.after)) {
                entry.afterIsHtml = true;
            } else {
                entry.after = formatEntry(entry.after);
                entry.afterIsHtml = false;
            }
        }
    });

    $scope.ok = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

MoveFlightModalController.$inject = ['$scope', '$modalInstance', 'data'];

function MoveFlightModalController($scope, $modalInstance, data) {
    $scope.type = 'moveFlight';
    $scope.flightObj = {};
    $scope.flightObj.lineItemList = data.lineItemList;
    _.each($scope.flightObj.lineItemList, function(lineItem) {
        let existingName = '';
        if (lineItem.hasOwnProperty('name')) {
            existingName = lineItem.name;
            if (existingName.length > 50) {
                existingName = existingName.substring(0, 50) + '...';
            }
        }
        let name = 'id: ' + lineItem.id;
        if (!existingName == '') {
            name = name + ', name: "' + existingName + '"';
        }
        if (lineItem.hasOwnProperty('campaign_name')) {
            let campaign_name = lineItem.campaign_name;
            if (campaign_name.length > 50) {
                campaign_name = campaign_name.substring(0, 50) + '...';
            }
            name = name + ', campaign_name: "' + campaign_name + '"';
        }
        lineItem.name = name;
    });
    $scope.flightObj.flightStatusList = data.flightStatusList;
    $scope.flightObj.flightWorkflowSteps = data.flightWorkflowSteps;
    $scope.flightObj.workflowActions = data.workflowActions;
    $scope.flightObj.selectedStatusId = data.statusId;
    $scope.flightObj.selectedWorkflowStepId = data.workflowStepId;
    $scope.moreThanOneFlight = data.moreThanOneFlight;

    $scope.ok = function() {
        $modalInstance.close($scope.flightObj);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

AutoCreateFlightsModalController.$inject = ['$scope', '$modalInstance', 'data', 'DisplayService'];

function AutoCreateFlightsModalController($scope, $modalInstance, data, DisplayService) {
    const MAX_DISPLAY_NAME_LENGTH = 40;
    $scope.type = 'autoCreateFlights';
    $scope.isRegenerate = false;
    const deletedFlightsArray = data.hasOwnProperty('deletedFlights') ? data.deletedFlights : undefined;
    if (deletedFlightsArray) {
        $scope.isRegenerate = true;
    }
    // We'll put auto-created flights in a table on top, and any existing flights in a separate table below, so it's
    // clear which ones get created.  We need to show the existing flights in case any distributed values are distributed
    // to them.
    $scope.deletedFlights = [];
    $scope.autoCreatedFlights = [];
    $scope.existingFlights = [];
    $scope.deletedFlightHeaders = [];
    $scope.autoCreatedFlightHeaders = [];
    $scope.existingFlightHeaders = [];
    $scope.hasExistingFlights = false;
    $scope.hasOverriddenValues = false;  // Does at least one existing flight have an overridden distributed value?

    // This modal has a variable number of columns (and rows) in its table.  Some identifier (name, flight_name, or id),
    // start_date and end_date (always), and any distributed-target fields.

    // Use 'flight' as the first column.  For auto-created flights, we'll use the temporary 'name' that was computed
    // in the backend, that looks like "New Flight #".  For existing flights, we'll use either 'name', 'flight_name', or
    // 'id', in order of preference ('id' is sure to be there).
    let deletedFlightHeader = {};
    deletedFlightHeader.field_name = 'flight';
    deletedFlightHeader.display_name = 'Deleted Flight';
    $scope.deletedFlightHeaders.push(deletedFlightHeader);

    let newFlightHeader = {};
    newFlightHeader.field_name = 'flight';
    newFlightHeader.display_name = 'New Flight';
    $scope.autoCreatedFlightHeaders.push(newFlightHeader);

    let existingFlightHeader = {};
    existingFlightHeader.field_name = 'flight';
    existingFlightHeader.display_name = 'Flight';
    $scope.existingFlightHeaders.push(existingFlightHeader);

    let statusHeader = {};
    statusHeader.field_name = 'status_name';
    statusHeader.display_name = 'Status (before closing)';
    $scope.deletedFlightHeaders.push(statusHeader);

    const startDateField = _.find(data.flightFields, function(field) {return field.field_name == 'start_date' && field.active == 1;});
    if (startDateField) {
        let startHeader = {};
        startHeader.field_name = startDateField.field_name;
        startHeader.display_name = startDateField.display_name;
        $scope.deletedFlightHeaders.push(startHeader);
        $scope.autoCreatedFlightHeaders.push(startHeader);
        $scope.existingFlightHeaders.push(startHeader);
    } else {
        let startHeader = {};
        startHeader.field_name = 'start_date';
        startHeader.display_name = 'Start Date';
        $scope.deletedFlightHeaders.push(startHeader);
        $scope.autoCreatedFlightHeaders.push(startHeader);
        $scope.existingFlightHeaders.push(startHeader);
    }

    const endDateField = _.find(data.flightFields, function(field) {return field.field_name == 'end_date' && field.active == 1;});
    if (endDateField) {
        let endHeader = {};
        endHeader.field_name = endDateField.field_name;
        endHeader.display_name = endDateField.display_name;
        $scope.deletedFlightHeaders.push(endHeader);
        $scope.autoCreatedFlightHeaders.push(endHeader);
        $scope.existingFlightHeaders.push(endHeader);
    } else {
        let endHeader = {};
        endHeader.field_name = 'end_date';
        endHeader.display_name = 'End Date';
        $scope.deletedFlightHeaders.push(endHeader);
        $scope.autoCreatedFlightHeaders.push(endHeader);
        $scope.existingFlightHeaders.push(endHeader);
    }

    const distributedTargetFields = _.filter(data.flightFields, function(field) {return field.input_type == 'distributed-target' && field.active == 1;});
    if (distributedTargetFields) {
        _.each(distributedTargetFields, function(distributedField) {
            let distrHeader = {};
            distrHeader.field_name = distributedField.field_name;
            // Protect against extra-long display names
            let displayName = distributedField.display_name;
            if (displayName.length > MAX_DISPLAY_NAME_LENGTH) {
                displayName = displayName.substring(0, MAX_DISPLAY_NAME_LENGTH) + '...';
            }
            distrHeader.display_name = displayName;
            $scope.autoCreatedFlightHeaders.push(distrHeader);
            $scope.existingFlightHeaders.push(distrHeader);
        });
    }

    if ($scope.isRegenerate) {
        _.each(deletedFlightsArray, function (flight) {
            let flightData = {};
            // Existing flights always have an 'id' property (and might have 'flight_name' or 'name')
            flightData.flight = flight.hasOwnProperty('name') ? flight['name'] :
                (flight.hasOwnProperty('flight_name') ? flight['flight_name'] : flight['id']);
            flightData.status_name = flight.status_name;
            flightData.start_date = flight.hasOwnProperty('start_date') ? flight.start_date : '';
            flightData.end_date = flight.hasOwnProperty('end_date') ? flight.end_date : '';
            $scope.deletedFlights.push(flightData);
        });
    }

    // We need to apply transformation so that integers and currency values are formatted properly.
    _.each(data.flights, function(flight) {
        let flightData = {};
        // Existing flights always have an 'id' property (and might have 'flight_name' or 'name'),
        // and auto-created flights always have a 'name' property.
        flightData.flight = flight.hasOwnProperty('name') ? flight['name'] :
            (flight.hasOwnProperty('flight_name') ? flight['flight_name'] : flight['id']);
        flightData.start_date = flight.hasOwnProperty('start_date') ? flight.start_date : '';
        flightData.end_date = flight.hasOwnProperty('end_date') ? flight.end_date : '';
        if (distributedTargetFields) {
            _.each(distributedTargetFields, function(distributedField) {
                if (flight.hasOwnProperty(distributedField.field_name)) {
                    flightData[distributedField.field_name] = DisplayService.applyTransformation(distributedField, ''+flight[distributedField.field_name])[distributedField.display_name];
                    if ((flight.status_name == 'Complete') ||
                        (flight.hasOwnProperty('overridden_fields') && flight.hasOwnProperty('id')
                        && flight.overridden_fields.includes(distributedField.field_name))) {
                        $scope.hasOverriddenValues = true;
                        flightData[distributedField.field_name] = flightData[distributedField.field_name] + ' *';
                    }
                }
            });
        }
        if (flight.hasOwnProperty('id')) {
            $scope.existingFlights.push(flightData);
            $scope.hasExistingFlights = true;
        } else {
            $scope.autoCreatedFlights.push(flightData);
        }
    });

    $scope.ok = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

ShowFormulaErrorsModalController.$inject = ['$scope', '$modalInstance', 'data'];

function ShowFormulaErrorsModalController($scope, $modalInstance, data) {
    $scope.type = 'showFormulaErrors';
    $scope.formulaErrors = data.formulaErrors;

    $scope.ok = function() {
        $modalInstance.close();
    };
}

RedistributeValuesModalController.$inject = ['$scope','$modalInstance', 'data', 'DisplayService'];

function RedistributeValuesModalController($scope, $modalInstance, data, DisplayService) {
    $scope.type = 'redistributeValues';
    const MAX_DISPLAY_NAME_LENGTH = 40;

    $scope.existingFlights = [];
    $scope.existingFlightHeaders = [];
    $scope.hasOverriddenValues = false;  // Does at least one existing flight have an overridden distributed value?

    // This modal has a variable number of columns (and rows) in its table.  Some identifier (name, flight_name, or id),
    // start_date and end_date (always), and any distributed-target fields.

    // Use 'flight' as the first column. We'll use either 'name', 'flight_name', or 'id', in order of preference
    // ('id' is sure to be there).
    let existingFlightHeader = {};
    existingFlightHeader.field_name = 'flight';
    existingFlightHeader.display_name = 'Flight';
    $scope.existingFlightHeaders.push(existingFlightHeader);

    let statusHeader = {};
    statusHeader.field_name = 'status_name';
    statusHeader.display_name = 'Status';
    $scope.existingFlightHeaders.push(statusHeader);

    const startDateField = _.find(data.flightFields, function(field) {return field.field_name == 'start_date' && field.active == 1;});
    if (startDateField) {
        let startHeader = {};
        startHeader.field_name = startDateField.field_name;
        startHeader.display_name = startDateField.display_name;
        $scope.existingFlightHeaders.push(startHeader);
    } else {
        let startHeader = {};
        startHeader.field_name = 'start_date';
        startHeader.display_name = 'Start Date';
        $scope.existingFlightHeaders.push(startHeader);
    }

    const endDateField = _.find(data.flightFields, function(field) {return field.field_name == 'end_date' && field.active == 1;});
    if (endDateField) {
        let endHeader = {};
        endHeader.field_name = endDateField.field_name;
        endHeader.display_name = endDateField.display_name;
        $scope.existingFlightHeaders.push(endHeader);
    } else {
        let endHeader = {};
        endHeader.field_name = 'end_date';
        endHeader.display_name = 'End Date';
        $scope.existingFlightHeaders.push(endHeader);
    }

    const distributedTargetFields = _.filter(data.flightFields, function(field) {return field.input_type == 'distributed-target' && field.active == 1;});
    if (distributedTargetFields) {
        _.each(distributedTargetFields, function(distributedField) {
            let distrHeader = {};
            distrHeader.field_name = distributedField.field_name;
            // Protect against extra-long display names
            let displayName = distributedField.display_name;
            if (displayName.length > MAX_DISPLAY_NAME_LENGTH) {
                displayName = displayName.substring(0, MAX_DISPLAY_NAME_LENGTH) + '...';
            }
            distrHeader.display_name = displayName;
            $scope.existingFlightHeaders.push(distrHeader);
        });
    }

    // We need to apply transformation so that integers and currency values are formatted properly.
    _.each(data.flights, function(flight) {
        let flightData = {};
        flightData.flight = flight.hasOwnProperty('name') ? flight['name'] :
            (flight.hasOwnProperty('flight_name') ? flight['flight_name'] : flight['id']);
        flightData.status_name = flight.status_name;
        flightData.start_date = flight.hasOwnProperty('start_date') ? flight.start_date : '';
        flightData.end_date = flight.hasOwnProperty('end_date') ? flight.end_date : '';
        if (distributedTargetFields) {
            _.each(distributedTargetFields, function(distributedField) {
                if (flight.hasOwnProperty(distributedField.field_name)) {
                    flightData[distributedField.field_name] = DisplayService.applyTransformation(distributedField, ''+flight[distributedField.field_name])[distributedField.display_name];
                    // Add star after the field value if it's overridden (or part of a Complete flight).
                    if ((flight.status_name == 'Complete') ||
                        (flight.hasOwnProperty('overridden_fields') && flight.hasOwnProperty('id')
                            && flight.overridden_fields.includes(distributedField.field_name))) {
                        $scope.hasOverriddenValues = true;
                        flightData[distributedField.field_name] = flightData[distributedField.field_name] + ' *';
                    }
                    // If field has been modified, make it bold.
                    if (flight.hasOwnProperty('__INTERNAL_modified_field_names') &&
                        flight.__INTERNAL_modified_field_names.includes(distributedField.field_name)) {
                        flightData[distributedField.field_name+'__font_weight__'] = 'bold';
                    } else {
                        flightData[distributedField.field_name+'__font_weight__'] = 'normal';
                    }
                }
            });
        }
        $scope.existingFlights.push(flightData);
    });

    $scope.ok = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CopyLineItemModalController.$inject = ['$scope','$modalInstance', 'data'];

function CopyLineItemModalController($scope, $modalInstance, data) {
    $scope.budgetManagementEnabled = data.budgetManagementEnabled;
    $scope.hasFlights = data.lineItem.__has_flights;
    $scope.disableCopyFlightsForClone = data.disableCopyFlightsForClone;
    var vm = this;

    vm.options = {
        isCopyingUploadedFiles: false,
        isCopyingFlights: false,
        copyArchivedFlights: false,
        clearTotalBudget: false,
        action: 'copy'
    };

    vm.isSelectedLineItem = function() {
        return data.lineItem.id == vm.options.targetLineItemId;
    };

    vm.ok = function() {
        $modalInstance.close(vm.options);
    };
    vm.cancel = function() {
        $modalInstance.dismiss();
    };
}


AddRoutingRuleSetModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function AddRoutingRuleSetModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {
    $scope.type = 'addRoutingRuleSet';
    $scope.ruleSetObj = {
        "workflowId": data.workflowId
    };
    var ruleSet = data.ruleSet;
    $scope.actionsArr = data.workflowActions;
    $scope.statusArr = data.statusList;
    $scope.isNew = false;
    if (ruleSet) {
        $scope.ruleSetObj.id = ruleSet.id;
        $scope.ruleSetObj.statusIds = ruleSet.status_ids;
        $scope.ruleSetObj.workflowActionId = ruleSet.workflow_action_id;
        $scope.ruleSetObj.isDefault = (ruleSet.is_default == '1');
        $scope.ruleSetText = "Update";
        $scope.isNew = false;
    } else {
        $scope.ruleSetText = "Create New";
        $scope.isNew = true;
    }
    $scope.addRuleSet = function(ruleSetForm) {
        if (ruleSetForm.$valid) {
            const action = $scope.actionsArr.find(action => action.id == $scope.ruleSetObj.workflowActionId);
            if ($scope.ruleSetObj.isDefault && action?.name == 'RESET_WORKFLOW') {
                $ioAlert.show('Error!', 'The workflow action cannot be RESET_WORKLFOW for the default routing rule set', 'error');
            } else {
                $modalInstance.close($scope.ruleSetObj);
            }
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    $scope.deleteRuleSet = function() {
        $modalInstance.close();
    };
}

AddRuleSetModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddRuleSetModalController($scope, $modalInstance, data) {
    $scope.type = 'addRuleSet';
    $scope.ruleSetObj = {};
    var ruleSet = data.ruleSet;
    if (ruleSet) {
        $scope.ruleSetObj.id = ruleSet.id;
        $scope.ruleSetObj.name = ruleSet.name;
        $scope.ruleSetText = "Update Rule Set";
    } else {
        $scope.ruleSetText = "Create New Rule Set";
    }
    $scope.addRuleSet = function(ruleSetForm) {
        if (ruleSetForm.$valid) {
            $modalInstance.close($scope.ruleSetObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

AddRuleModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddRuleModalController($scope, $modalInstance, data) {
    $scope.type = 'addRule';
    $scope.ruleObj = {
        "ruleSetId": data.ruleSetId
    };
    $scope.ruleOperationArr = data.ruleOperations;
    const rule = data.rule;
    if (rule) {
        $scope.ruleObj.id = rule.id;
        $scope.ruleObj.ruleOperationId = rule.rule_operation_id;
        $scope.ruleObj.ruleTarget = rule.rule_target;
        $scope.ruleObj.ruleValue = rule.rule_value;
        $scope.ruleText = "Update Rule";
    } else {
        $scope.ruleText = "Create New Rule";
    }
    $scope.addRule = function(ruleForm) {
        if (ruleForm.$valid) {
            $modalInstance.close($scope.ruleObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.onRuleTargetChange = function(element, event) {
        $scope.ruleObj.ruleTarget = event.val;
    };

    $scope.ruleTargetSelect2Options = function() { return {}; };

    $scope.ruleTargetSelect2Values = _.map(data.ruleTargets, function(target) {
        const text = target.field_name + ' -- ' + target.display_name;
        return { id: target.field_name, text: text };
    });

    $scope.ruleTargetSelect2SelectedValues = _.find($scope.ruleTargetSelect2Values, function(option) {
        return rule && option.id === rule.rule_target
    }) || {};
}

CreateWorkflowModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClusterService', '$ioAlert', '$confirm', 'WorkflowsService'];

function CreateWorkflowModalController($scope, $modalInstance, data, ClusterService, $ioAlert, $confirm, WorkflowsService) {
    $scope.type = 'createWorkflow';

    let workflow = data.workflow;
    let workflowTypes = data.workflowTypes;
    let orderStatusList = data.orderStatusList;
    let clientStatusList = data.clientStatusList;
    let lineItemStatusList = data.lineItemStatusList;
    let flightStatusList = data.flightStatusList;
    let clusters = data.clusters;
    let lineItemRefList = data.lineItemRefList;
    let flightRefList = data.flightRefList;
    let stepGroupsList = data.stepGroups;
    let StepGroupService = data.StepGroupService;
    let activeWorkflowForProduct = null;
    $scope.workflowObj = {};
    $scope.typeArr = workflowTypes;
    $scope.statusArr = [];
    $scope.productArr = [];
    $scope.clusterArr = clusters;
    $scope.stepGroups = stepGroupsList;
    $scope.steps = [];

    $scope.toggleWorkflow = function(workflow) {
        if (workflow == 1) {
            $scope.statusArr = orderStatusList;
            $scope.clusterArr = clusters;
        } else if (workflow == 2) {
            $scope.statusArr = lineItemStatusList;
            $scope.productArr = lineItemRefList;
            $scope.productOrTypeSelected($scope.workflowObj.productId, workflow);
        } else if (workflow == 3) {
            $scope.statusArr = clientStatusList;
            $scope.clusterArr = clusters;
        } else if (workflow == 4) {
            $scope.statusArr = flightStatusList;
            $scope.productArr = flightRefList;
            $scope.productOrTypeSelected($scope.workflowObj.productId, workflow);
        }

        $scope.statusArr = _.orderBy($scope.statusArr, 'name');
    };

    $scope.getGroupSteps = function(workflowStepGroupId) {
        StepGroupService.getStepsXrefs({ "workflowStepGroupId": workflowStepGroupId }).then(function(response) {
            $scope.steps = response.workflowStepGroupXrefs;
        }, function() {
            console.log("Error getting steps");
        })
    };

    $scope.productOrTypeSelected = function(productId, typeId) {
        if (productId && (typeId == '2' || typeId == '4')) {
            activeWorkflowForProduct = null;  // Reset (if it was set) now that we're waiting for a new one.
            WorkflowsService.getActiveWorkflowForProduct(productId, typeId).then(function(response) {
                activeWorkflowForProduct = response;
            }, function(error) {
                console.log('Error fetching active workflow for product ' + productId + ': ' + error);
            });
        }
    }

    if (workflow) {
        $scope.workflowObj.id = workflow.id;
        $scope.workflowObj.name = workflow.name;
        $scope.workflowObj.typeId = workflow.type_id;
        $scope.workflowObj.isDefault = workflow.isDefault;
        $scope.workflowObj.active = workflow.active;
        $scope.workflowObj.productId = workflow.product_id;
        $scope.workflowObj.clusterIds = workflow.cluster_ids;
        $scope.workflowObj.initialStatusId = workflow.initial_status_id;
        $scope.workflowObj.workflowStepGroupId = workflow.workflow_step_group_id;
        $scope.workflowObj.initialStepId = workflow.initial_step_id;
        $scope.toggleWorkflow(workflow.type_id);
        $scope.getGroupSteps($scope.workflowObj.workflowStepGroupId);
        $scope.workflowText = "Update Workflow";
        $scope.workflowObj.typeDisabled = true;
        $scope.productOrTypeSelected($scope.workflowObj.productId, workflow);

    } else {
        $scope.workflowText = "Create New Workflow";
    }

    $scope.addWorkflow = function(workflowForm) {
        if (workflowForm.$valid) {
            if (($scope.workflowObj && ($scope.workflowObj.typeId == '1' || $scope.workflowObj.typeId == '3') &&
                (($scope.workflowObj.clusterIds && $scope.workflowObj.clusterIds.length > 0) || $scope.workflowObj.isDefault || !$scope.workflowObj.active)) ||
                ($scope.workflowObj && ($scope.workflowObj.typeId == '2' || $scope.workflowObj.typeId == '4') && $scope.workflowObj.productId)) {

                // Note that there is a race condition where the activeWorkflowForProduct might not have been received
                // yet from the backend.  If this happens, no harm other than the warning not showing up.  And it's a
                // very lightweight query not even doing a JOIN, and the productId is not the last field in the modal
                // window, so it's extremely unlikely to occur in practice.
                if ($scope.workflowObj &&
                    ($scope.workflowObj.typeId == '2' || $scope.workflowObj.typeId == '4') &&
                    $scope.workflowObj.active == true && $scope.workflowObj.productId &&
                    activeWorkflowForProduct != $scope.workflowObj.id) {
                    $confirm.open({
                        size: 'sm',
                        text: 'There is an active workflow associated with this product already. Would you like to activate this one and deactivate the other?'
                    }).then(function() {
                        $modalInstance.close($scope.workflowObj);
                    }, function() { });
                } else {
                    $modalInstance.close($scope.workflowObj);
                }
                
            } else {
                if ($scope.workflowObj && ($scope.workflowObj.typeId == '1' || $scope.workflowObj.typeId == '3')) {
                    $ioAlert.show('Error!', 'Please select at least one Business Unit, or make it the default workflow', 'error');
                } else {
                    $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
                }
            }
        } else {
            $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

ShowRuleSetModalController.$inject = ['$scope', '$modalInstance', 'data'];

function ShowRuleSetModalController($scope, $modalInstance, data) {
    $scope.type = 'addRuleSet';

    var ruleSet = data.ruleSet;
    var workflowActions = data.workflowActions;
    var workflowId = data.workflowId;
    var statusList = data.statusList;

    $scope.scheduledRouting = data.scheduledRouting;
    $scope.ruleSetObj = {
        "workflowId": workflowId
    };
    $scope.actionsArr = workflowActions;
    $scope.statusArr = statusList;
    if (ruleSet) {
        $scope.ruleSetObj.id = ruleSet.id;
        $scope.ruleSetObj.statusId = ruleSet.status_id;
        $scope.ruleSetObj.workflowActionId = ruleSet.workflow_action_id;

        $scope.ruleSetText = "Update Routing Rule Set";
    } else {
        $scope.ruleSetText = "Create New Routing Rule Set";
    }
    $scope.addRuleSet = function(ruleSetForm) {
        if (ruleSetForm.$valid) {
            $modalInstance.close($scope.ruleSetObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateRoutingRuleModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function CreateRoutingRuleModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {
    $scope.type = 'createRoutingRule';
    var ruleSetId = data.ruleSetId;
    var routingRule = data.routingRule;
    var statusList = data.statusList;
    var workflowActions = data.workflowActions;
    var workflowTypeName = data.workflowTypeName;
    var scheduledRouting = data.scheduledRouting;
    var steps = data.steps;
    $scope.scheduledRouting = scheduledRouting;
    $scope.routingRuleObj = {
        "routingRuleSetId": ruleSetId
    };
    $scope.isNew = true;
    $scope.steps = _.orderBy(steps, 'name');

    $scope.statusArr = _.orderBy(statusList, 'name');
    $scope.actionsArr = workflowActions;
    $scope.functionsArr = ['recalculate','reset_workflow','close_tasks'];
    if (workflowTypeName == 'Client') {
        $scope.showAuxiliaryActionUp = false;
        $scope.showAuxiliaryActionDown = true;
        $scope.auxiliaryActionDownText = 'Auxiliary Action to Send down to Order Workflows';
        $scope.functionsArr = ['reset_workflow','close_tasks']; // There are no calculated fields for clients
    } else if (workflowTypeName == 'Order') {
        $scope.showAuxiliaryActionUp = true;
        $scope.showAuxiliaryActionDown = true;
        $scope.auxiliaryActionUpText = 'Auxiliary Action to Send up to Client Workflow';
        $scope.auxiliaryActionDownText = 'Auxiliary Action to Send down to Line Item Workflows';
    } else if (workflowTypeName == 'LineItem') {
        $scope.showAuxiliaryActionUp = true;
        $scope.showAuxiliaryActionDown = true;
        $scope.auxiliaryActionUpText = 'Auxiliary Action to Send up to Order Workflow';
        $scope.auxiliaryActionDownText = 'Auxiliary Action to Send down to Flight Workflows';
    } else if (workflowTypeName == 'Flight') {
        $scope.showAuxiliaryActionUp = true;
        $scope.showAuxiliaryActionDown = false;
        $scope.auxiliaryActionUpText = 'Auxiliary Action to Send up to Line Item Workflows';
    }
    if (routingRule) {
        $scope.routingRuleObj.id = routingRule.id;
        $scope.routingRuleObj.workflowStepId = routingRule.workflow_step_id;
        $scope.routingRuleObj.statusId = routingRule.status_id;
        $scope.routingRuleObj.defaultRule = (routingRule.default_rule == '1');
        $scope.routingRuleObj.workflowStepId = routingRule.workflow_step_id;
        $scope.routingRuleObj.auxiliaryActionUp = routingRule.auxiliary_action_up;
        $scope.routingRuleObj.auxiliaryActionDown = routingRule.auxiliary_action_down;
        $scope.routingRuleObj.runFunction = routingRule.run_function;

        if (scheduledRouting) {
            $scope.routingRuleObj.schedule = routingRule.schedule;
            $scope.routingRuleObj.reference = routingRule.reference;
            $scope.routingRuleObj.numberOfDays = routingRule.numberOfDays;
            $scope.routingRuleObj.timeFrame = routingRule.timeFrame;
        }

        $scope.routingText = "Update Routing Rule";
        $scope.isNew = false;
    } else {
        $scope.routingText = "Create New Routing Rule";
        $scope.isNew = true;
    }
    $scope.addRoutingRule = function(routingRuleForm) {
        if (routingRuleForm.$valid) {
            $modalInstance.close($scope.routingRuleObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    /*
    * Handle modal close of delete routingrule
    */
    $scope.deleteRoutingRule = function() {
        $modalInstance.close();
    };
}

CreateRoutingConditionModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function CreateRoutingConditionModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {
    $scope.type = 'createRoutingCondition';

    var ruleSetId = data.ruleSetId;
    var routingCondition = data.routingCondition;
    var routingRules = data.routingRules;
    var tapIORuleSets = data.tapIORuleSets;

    $scope.routingConditionObj = {
        "routingRuleSetId": ruleSetId
    };
    $scope.isNew = true;
    $scope.routingRulesArr = routingRules;
    tapIORuleSets =  _.orderBy(tapIORuleSets, (item) => item.name.toLowerCase());
    $scope.tapIORuleSetsArr = tapIORuleSets;
    if (routingCondition) {
        $scope.routingConditionObj.id = routingCondition.id;
        $scope.routingConditionObj.ruleSetId = routingCondition.rule_set_id;
        $scope.routingConditionObj.trueRoutingRuleId = routingCondition.true_routing_rule_id;
        $scope.routingConditionObj.falseRoutingRuleId = routingCondition.false_routing_rule_id;
        $scope.conditionText = "Update Routing Condition";
        $scope.isNew = false;
    } else {
        $scope.conditionText = "Create New Routing Condition";
        $scope.isNew = true;
    }
    $scope.addRoutingCondition = function(routingConditionForm) {
        if (routingConditionForm.$valid) {
            if ($scope.routingConditionObj.trueRoutingRuleId == $scope.routingConditionObj.falseRoutingRuleId) {
                $ioAlert.show('Error!', 'True Routing rule id and false routing rule id cannot be the same', 'error');
            } else {
                $modalInstance.close($scope.routingConditionObj);
            }
        }
    };

    /*
    * Handle modal close of delete routing condition
    */
    $scope.deleteRoutingCondition = function(conditionId) {
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateWorkflowTaskModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function CreateWorkflowTaskModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {
    $scope.type = 'createWorkflowTask';

    var workflowId = data.workflowId;
    var task = data.task;
    var workflowActions = data.workflowActions;
    var routingRuleId = data.routingRuleId;
    var tasksList = data.tasksList;
    $scope.unifySharedDisabled = true;

    $scope.isRoutingRuleId = true;
    $scope.taskObj = {
        "workflowId": workflowId,
        "routingRuleId": routingRuleId
    };
    $scope.isNew = false;
    $scope.actionArr = workflowActions;
    $scope.tasksList = tasksList;
    $scope.toggleUnifyShared = function() {
        $scope.unifySharedDisabled = false;
        if ($scope.taskObj.shared == false) {
            $scope.taskObj.unifyShared = false;
            $scope.unifySharedDisabled = true;
        } else if ($scope.taskObj.shared == true) {
            $scope.unifySharedDisabled = false;
        }
    }
    if (task) {
        $scope.taskObj.id = task.id;
        $scope.taskObj.workflowActionId = task.workflow_action_id;
        $scope.taskObj.taskId = task.task_id;
        $scope.taskObj.onDemand = (task.on_demand == 1) ? true : false;
        $scope.taskObj.shared = (task.shared == 1) ? true : false;
        $scope.toggleUnifyShared();
        $scope.taskObj.unifyShared = (task.unify_shared == 1) ? true : false;
        $scope.taskObj.asynchronous = (task.asynchronous == 1) ? true : false;
        $scope.taskObj.sequence = parseInt(task.sequence);
        $scope.taskObj.autoAssign = task.auto_assign;
        $scope.taskText = "Update Workflow Task";
        $scope.isNew = false;
    } else {
        $scope.taskText = "Create New Workflow Task";
        $scope.isNew = true;
        $scope.taskObj.unifyShared = false;
        $scope.taskObj.asynchronous = false;
    }

    $scope.addTask = function(taskForm) {
        if (taskForm.$valid) {
            $scope.taskObj.onDemand = ($scope.taskObj.onDemand === true) ? '1' : '0';
            $scope.taskObj.shared = ($scope.taskObj.shared === true) ? '1' : '0';
            $scope.taskObj.unifyShared = ($scope.taskObj.unifyShared === true) ? '1' : '0';
            $scope.taskObj.asynchronous = ($scope.taskObj.asynchronous === true) ? '1' : '0';
            if ($scope.taskObj.autoAssign === 'create_task_user_id') {
                if ($scope.taskObj.onDemand === '1') {
                    $modalInstance.close($scope.taskObj);
                } else {
                    $ioAlert.show('Error!', 'create_task_user_id is only working for on demand task', 'error');
                }
            } else {
                $modalInstance.close($scope.taskObj);
            }
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    /*
    * Handle modal close of delete task
    */
    $scope.deleteTask = function(taskId) {
        $modalInstance.close();
    };
}

CreateWorkflowTaskInterlockingModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function CreateWorkflowTaskInterlockingModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {
    $scope.type = 'createWorkflowTaskInterlocking';

    var workflowId = data.workflowId;
    var interlocking = data.interlocking;
    var workflowActions = data.workflowActions;
    var routingRuleId = data.routingRuleId;
    var workflowTasks = data.workflowTasks;

    $scope.isRoutingRuleId = true;
    $scope.interlockingObj = {
        "workflowId": workflowId,
        "routingRuleId": routingRuleId,
        "selectedWorkflowTaskIds": []
    };

    $scope.actionArr = workflowActions;
    $scope.workflowTasks = workflowTasks;
    $scope.workflowTaskIds = [];
    $scope.selectedWorkflowTaskIds = [];

    if (interlocking) {
        $scope.interlockingObj.id = interlocking.id;
        $scope.interlockingObj.workflowActionId = interlocking.workflow_action_id;
        $scope.interlockingObj.condition = interlocking.condition;
        $scope.interlockingObj.selectedWorkflowTaskIds = interlocking.selected_workflow_task_ids;
        $scope.interlockingText = "Update Interlocking Task Rule";
        $scope.isNew = false;

        // add memory logic for update
        _.each($scope.workflowTasks, function(workflowTask) {
            if($scope.interlockingObj.selectedWorkflowTaskIds.length > 0 &&
                $scope.interlockingObj.selectedWorkflowTaskIds.contains(workflowTask.id)
            ) {
                let selected = $scope.interlockingObj.selectedWorkflowTaskIds.contains(workflowTask.id);
                $scope.workflowTaskIds[workflowTask.id] = selected;
            }
        });
        $scope.selectedWorkflowTaskIds = interlocking.selected_workflow_task_ids;
    } else {
        $scope.interlockingText = "Add Interlocking Task Rule";
        $scope.isNew = true;
    }

    $scope.selectWorkflowTaskForInterlockingTaskRule = function(id) {
        if ($scope.workflowTaskIds[id]) {
            $scope.selectedWorkflowTaskIds.push(id);
        } else {
            var index = $scope.selectedWorkflowTaskIds.indexOf(id);
            $scope.selectedWorkflowTaskIds.splice(index, 1);
        }

        $scope.interlockingObj.selectedWorkflowTaskIds = $scope.selectedWorkflowTaskIds;
    };
    
    $scope.addInterlocking = function(interlockingForm) {
        if($scope.selectedWorkflowTaskIds.length == 0) {
            return;
        }
        if (interlockingForm.$valid) {
            $modalInstance.close($scope.interlockingObj);
        }
    };

    /*
    * Handle modal close of delete interlocking
    */
    $scope.deleteLock = function() {
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

AddWorkflowTaskModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddWorkflowTaskModalController($scope, $modalInstance, data) {
    $scope.type = 'createWorkflowTask';

    var workflowId = data.workflowId;
    var task = data.task;
    var workflowActions = data.workflowActions;
    var tasksList = data.tasksList;

    $scope.isRoutingRuleId = false;
    $scope.taskObj = {
        "workflowId": workflowId
    };
    $scope.actionArr = workflowActions;
    $scope.tasksList = tasksList;
    if (task) {
        $scope.taskObj.id = task.id;
        $scope.taskObj.workflowActionId = task.workflow_action_id;
        $scope.taskObj.routingRuleId = task.routing_rule_id;
        $scope.taskObj.taskId = task.task_id;
        $scope.taskObj.sequence = parseInt(task.sequence);
        $scope.taskObj.autoAssign = task.auto_assign;
        $scope.taskText = "Update";
    } else {
        $scope.taskText = "Create New";
    }
    $scope.addTask = function(taskForm) {
        if (taskForm.$valid) {
            $modalInstance.close($scope.taskObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateWorkflowActionModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateWorkflowActionModalController($scope, $modalInstance, data) {
    $scope.type = 'createWorkflowAction';
    const workflowAction = data.workflowAction;

    $scope.workflowActionObj = {};

    if (workflowAction) {
        $scope.workflowActionObj.id = workflowAction.id;
        $scope.workflowActionObj.name = workflowAction.name;
        $scope.workflowActionObj.active = (workflowAction.active == 1);
        $scope.workflowActionObj.custom_edit = (workflowAction.custom_edit && workflowAction.custom_edit == 1);
        $scope.workflowActionObj.mutable = workflowAction.mutable;
        $scope.workflowActionObj.sequence = parseInt(workflowAction.sequence);

        $scope.workflowText = "Update Workflow Action";
    } else {
        $scope.workflowActionObj.mutable = 1
        $scope.workflowText = "Create New Workflow Action";
    }

    $scope.addOrEditWorkflowAction = function(workflowActionForm) {
        if (workflowActionForm.$valid) {
            $modalInstance.close($scope.workflowActionObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateCustomStatusModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateCustomStatusModalController($scope, $modalInstance, data) {
    $scope.type = 'createCustomStatus';
    const status = data.status;
    $scope.statusTypes = data.statusTypes;
    $scope.statusObj = {};

    if (status) {
        $scope.statusObj.id = status.id;
        $scope.statusObj.name = status.name;
        $scope.statusObj.typeId = status.type_id;
        $scope.statusObj.description = status.description;
        $scope.statusObj.active = (status.active == 1);

        $scope.statusText = "Update custom status";
    } else {
        $scope.statusText = "Create new custom status";
    }

    $scope.addOrEditStatus = function(statusForm) {
        if (statusForm.$valid) {
            $modalInstance.close($scope.statusObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateCancelReasonModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateCancelReasonModalController($scope, $modalInstance, data) {
    $scope.type = 'createCancelReason';
    var cancelReason = data.cancelReason;

    $scope.cancelReasonObj = {};

    if (cancelReason) {
        $scope.cancelReasonObj.id = cancelReason.id;
        $scope.cancelReasonObj.name = cancelReason.name;
        $scope.cancelReasonObj.type = cancelReason.type;
        $scope.cancelReasonObj.disableName = (cancelReason.mutable == 0);
        $scope.cancelReasonObj.active = (cancelReason.active == 1);
        $scope.cancelReasonObj.disableType = true;
        $scope.cancelReasonText = "Update Cancellation Reason";
    } else {
        $scope.cancelReasonObj.disableType = false;
        $scope.cancelReasonObj.disableName = false;
        $scope.cancelReasonText = "Create New Cancellation Reason";
    }
    $scope.cancelreasontypes = ['order', 'lineitem', 'flight'];
    $scope.addOrEditCancelReason = function(cancelReasonForm) {
        if (cancelReasonForm.$valid) {
            $modalInstance.close($scope.cancelReasonObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateProductModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert'];

function CreateProductModalController($scope, $modalInstance, data, $ioAlert) {
    $scope.type = 'createProduct';
    const product = data.product;
    $scope.headerText = 'New Product';
    const clusters = data.clusters;
    // This code needs to be removed if the other cluster_ids
    // are integer in the future
    clusters.forEach((cluster) => {
        if (cluster.id == 0) {
            cluster.id = String(0);
            return;
        }
    });
    $scope.productObj = {};
    $scope.productCategories = data.productCategories;
    $scope.clusterArr = clusters;
    $scope.orderTypes = data.orderTypes;
    $scope.pushServices = data.pushEnabledServices;
    $scope.TAServices = data.TAServices;
    $scope.flightTimeFrames = data.flightTimeFrames;
    $scope.monthlyFlightStartOnValues = data.monthlyFlightStartOnValues;
    $scope.weeklyFlightStartDaysOfWeek = data.weeklyFlightStartDaysOfWeek;

    if (product) {
        $scope.productObj.name = product.name;
        $scope.headerText = 'Update Product';
        $scope.productObj.clusterIds = product.cluster_ids;
        // This code needs to be removed if the other cluster_ids
        // are integer in the future
        $scope.productObj.clusterIds.forEach((e, index, ids) => {
               ids[index] = String(e);
        });
        $scope.productObj.orderTypeIds = product.order_type_ids;
        $scope.productObj.id = product.id;
        $scope.productObj.categoryId = product.category_id;
        $scope.productObj.active = (product.active == 1);
        $scope.productObj.bookable = (product.bookable == 1);
        $scope.productObj.enableFlights = (product.enable_flights == 1);
        $scope.productObj.multipleMapping = (product.multiple_mapping == 1);
        $scope.productObj.serviceId = product.service_id;
        $scope.productObj.taServiceId = product.ta_service_id;
        $scope.productObj.flightAutoCreateTimeframe = product.flight_auto_create_timeframe;
        $scope.productObj.monthlyFlightStartOn = product.monthly_flight_start_on;
        $scope.productObj.weeklyFlightStartOn = product.day_of_week_start_on;
        $scope.productObj.useFlightsAsPlacements = (product.use_flights_as_placements == 1);
    } else {
        $scope.productObj.orderTypeIds = $scope.orderTypes.map(type => type.id);
    }

    $scope.addProduct = function(productForm) {
        if (productForm.$valid) {
            if($scope.productObj && $scope.productObj.clusterIds && $scope.productObj.clusterIds.length > 0) {
                $modalInstance.close($scope.productObj);
            } else {
                $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
            }
        } else {
            $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
        }
    };

    /*
    * Handle BU's selection
    */
    $scope.handleOnSelection = function(selectedValue) {
        _.each(selectedValue, function (val) {
            if(val == 0) {
                $scope.clusterArr = [];
                $scope.productObj.clusterIds = [];
                $scope.productObj.clusterIds.push(val);
            }
        });
    }

    /*
    * Handle BU's removal
    */
    $scope.handleOnRemoval = function(removedValue) {
        if(Array.isArray(removedValue) && removedValue.length){
        }else {
            $scope.clusterArr = data.clusters;
        }
    }

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CreateProductGroupModalController.$inject = ['$scope', '$modalInstance', 'data'];

function CreateProductGroupModalController($scope, $modalInstance, data) {
    $scope.type = 'createProductGroup';
    var group = data.group;
    $scope.groupObj = {};
    $scope.groupObj.hideConditionTypes = data.hideConditionTypes;
    $scope.orderTypes = data.orderTypes;
    $scope.roleTypes = data.roleTypes;
    if (group) {
        $scope.modalTitle = "Update Product Group"
        $scope.groupObj.name = group.group_name;
        $scope.groupObj.id = group.id;
        $scope.groupObj.displayOrder = parseInt(group.group_display_order);
        $scope.groupObj.active = (group.active == 1);
        $scope.groupObj.hideForConditionType = group.hideForConditionType;
        $scope.groupObj.hideForCondition = group.hideForCondition;
        switch (group.hideForConditionType) {
            case "Order Type":
                $scope.groupObj.hideConditionValues = data.orderTypes;
                break;
            case "Role Type":
                $scope.groupObj.hideConditionValues = data.roleTypes;
                break;
        }
    } else {
        $scope.groupObj.active = true;
        if (data.allGroups && data.allGroups.length) {
            $scope.groupObj.displayOrder = Math.max.apply(Math, data.allGroups.map(function(o) {
                return parseInt(o.group_display_order);
            })) + 1;
        } else {
            $scope.groupObj.displayOrder = 1;
        }
        $scope.modalTitle = "New Product Group"
    }

    $scope.selectCondtionType = function() {
        $scope.groupObj.hideForCondition = undefined;
        switch ($scope.groupObj.hideForConditionType) {
            case 'Order Type':
                $scope.groupObj.hideConditionValues = $scope.orderTypes;
                break;
            case 'Role Type':
                $scope.groupObj.hideConditionValues = $scope.roleTypes;
                break;
            default:
                $scope.groupObj.hideConditionValues = undefined;
        }
    };

    $scope.clearHideCondition = function() {
        $scope.groupObj.hideForConditionType = undefined;
        $scope.groupObj.hideForCondition = undefined;
        $scope.groupObj.hideConditionValues = undefined;
    };

    $scope.addGroup = function(groupForm) {
        if (groupForm.$valid) {
            if ($scope.groupObj && $scope.groupObj.name)
                $modalInstance.close($scope.groupObj);
        } else {}
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CloneProductModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert'];

function CloneProductModalController($scope, $modalInstance, data, $ioAlert) {
    $scope.type = 'cloneProduct';
    $scope.productId = data.productId;
    $scope.cloneObj = {};
    $scope.cloneObj.name = null;

    $scope.cloneProduct = function(cloneForm) {
        if (cloneForm.$valid && $scope.cloneObj && $scope.cloneObj.name) {
            $modalInstance.close($scope.cloneObj);
        } else {
            $ioAlert.show('', 'Please enter all required fields.', 'error');
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

CloneFormModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert'];

function CloneFormModalController($scope, $modalInstance, data, $ioAlert) {
    $scope.type = 'cloneForm';
    $scope.formId = data.formId;
    $scope.cloneObj = {};
    $scope.cloneObj.name = null;

    $scope.cloneForm = function(cloneFormModal) {
        if (cloneFormModal.$valid && $scope.cloneObj && $scope.cloneObj.name) {
            $modalInstance.close($scope.cloneObj);
        } else {
            $ioAlert.show('', 'Please enter all required fields.', 'error');
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

UpdateProductsHideConditionModalController.$inject = ['$scope', '$modalInstance', 'data'];

function UpdateProductsHideConditionModalController($scope, $modalInstance, data) {
    $scope.type = 'updateProductsHideConditionForm';
    $scope.headerTitle = "Update Hide Condition";
    $scope.conditionObj = {};
    var group = data.group;
    $scope.group = data.group;
    $scope.conditionObj.hideConditionTypes = data.hideConditionTypes;
    $scope.orderTypes = data.orderTypes;
    $scope.roleTypes = data.roleTypes;
    $scope.conditionObj.groupName = group.group_name;
    $scope.conditionObj.id = group.id;
    $scope.conditionObj.groupDisplayOrder = parseInt(group.group_display_order);
    $scope.conditionObj.active = (group.active === true || group.active == '1');
    $scope.conditionObj.hideForConditionType = group.hideForConditionType;
    $scope.conditionObj.hideForCondition = group.hideForCondition;
    $scope.conditionObj.hideForConditionValue = group.hideForConditionValue;
    switch (group.hideForConditionType) {
        case "Order Type":
            $scope.conditionObj.hideConditionValues = data.orderTypes;
            break;
        case "Role Type":
            $scope.conditionObj.hideConditionValues = data.roleTypes;
            break;
    }
    $scope.selectCondtionType = function() {
        $scope.conditionObj.hideForCondition = undefined;
        switch ($scope.conditionObj.hideForConditionType) {
            case 'Order Type':
                $scope.conditionObj.hideConditionValues = $scope.orderTypes;
                break;
            case 'Role Type':
                $scope.conditionObj.hideConditionValues = $scope.roleTypes;
                break;
            default:
                $scope.conditionObj.hideConditionValues = undefined;
        }
    };

    $scope.clearHideCondition = function() {
        $scope.conditionObj.hideForConditionType = undefined;
        $scope.conditionObj.hideForCondition = undefined;
        $scope.conditionObj.hideConditionValues = undefined;
    };

    $scope.addHideCondition = function(groupForm) {
        if (groupForm.$valid) {
            $modalInstance.close($scope.conditionObj);
        }
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}


AddProductContentModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddProductContentModalController($scope, $modalInstance, data) {
    $scope.type = 'addProductContent';
    var productId = data.productId;
    var lookupAttributes = data.lookupAttributes;
    var productContent = data.productContent;

    $scope.productContentObj = {
        "productId": productId
    };

    $scope.lookupAttributes = lookupAttributes;

    if (productContent) {
        $scope.productContentObj.lookupContents = [];

        for (var i = 0; i < productContent.length; i++) {
            for (var j = 0, size = $scope.lookupAttributes.length; j < size; j++) {
                if ($scope.lookupAttributes[j].id == productContent[i].lookup_content_id) {
                    $scope.productContentObj.lookupContents.push($scope.lookupAttributes[j]);
                }
            }
        }
    }

    $scope.addProdContent = function(productContentForm) {
        if (productContentForm.$valid) {
            $modalInstance.close($scope.productContentObj);
        }
    };

    $scope.selectAllContents = function() {
        $scope.productContentObj.lookupContents = [];
        for (var j = 0, size = $scope.lookupAttributes.length; j < size; j++) {
            $scope.productContentObj.lookupContents.push($scope.lookupAttributes[j]);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.tagHandler = function() {
        return null;
    }
}

LookupContentCloneModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClusterService', '$ioAlert', 'ProductService'];

function LookupContentCloneModalController($scope, $modalInstance, data, ClusterService, $ioAlert, ProductService) {
    $scope.type = 'lookupContentClone';
    const currentClusterId = ClusterService.clusterIds[0];
    const currentProductId = data.productId;

    $scope.clusterArr = data.clusters;
    $scope.products = getUniqueData(data.products,'id');
    $scope.contentTypes = data.lookupTypes;
    $scope.cloneObj = {};
    // $scope.cloneObj.destClusterId = null;
    // $scope.cloneObj.destProductId = null;

    function getUniqueData(arr, comp) {

        const unique = arr
             .map(e => e[comp])
      
          .map((e, i, final) => final.indexOf(e) === i && i)
      
          .filter(e => arr[e]).map(e => arr[e]);
      
         return unique;
      }
    $scope.selectAllProducts = function() {
        $scope.cloneObj.destProductIds = [];
        _.each($scope.products, function(product){
            if (product.id != currentProductId) {
                $scope.cloneObj.destProductIds.push(product.id);
            }
        });
    }

    $scope.selectAllClusters = function() {
        $scope.cloneObj.destClusterIds = [];
        _.each($scope.clusterArr, function(cluster){
            if (cluster.id != currentClusterId) {
                $scope.cloneObj.destClusterIds.push(cluster.id);
            }
        });
    }

    $scope.selectAllContentTypes = function() {
        $scope.cloneObj.lookupTypeIds = [];
        _.each($scope.contentTypes, function(contentType){
            $scope.cloneObj.lookupTypeIds.push(contentType.id);
        });
    }

    $scope.cloneLookupContent = function(cloneForm) {
        if (!($scope.cloneObj.destProductIds && $scope.cloneObj.destProductIds.length) ||
            !($scope.cloneObj.destClusterIds && $scope.cloneObj.destClusterIds.length)) {
            $ioAlert.show('', 'You must select a destination products and business units.', 'error');
        } else if ($scope.cloneObj.destClusterIds.indexOf(currentClusterId) > -1 &&
            $scope.cloneObj.destProductIds.indexOf(currentProductId) > -1
        ) {
            const message = 'source business unit and source product cannot be selected at the same time as the destination.';
            $ioAlert.show('', message, 'error');
        } else if (cloneForm.$valid) {
            $modalInstance.close($scope.cloneObj);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.updateDestinationProducts = function() {
        ProductService.getProducts($scope.cloneObj.destClusterId, true).then(function() {
            $scope.products = ProductService.products;
        }, function() {
            console.log("Error getting products for business unit: " + clusterId);
        });
    };

    $scope.tagHandler = function() {
        return null;
    }

}

LookupContentForClusterCloneModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClusterService', '$ioAlert'];

function LookupContentForClusterCloneModalController($scope, $modalInstance, data, ClusterService, $ioAlert) {
    $scope.type = 'lookupContentForClusterClone';
    const clusters = data.clusters;
    $scope.cloneObj = {};
    $scope.cloneObj.sourceClusterId = ClusterService.clusterIds[0];

    _.each(clusters, function(clusterObj, index) {
        if (clusterObj.id == "0") {
            clusters.splice(index, 1);
            return false;
        }
    });
    $scope.clusterArr = clusters;

    $scope.selectAllClusters = function() {
        $scope.cloneObj.destClusterIds = [];
        for (let j = 0, size = $scope.clusterArr.length; j < size; j++) {
            $scope.cloneObj.destClusterIds.push($scope.clusterArr[j].id);
        }
    };

    /*
     * Validate source and destination cluster Id's
     */
    $scope.cloneLookupForClusterContent = function(cloneForm) {
        if (!($scope.cloneObj.destClusterIds && $scope.cloneObj.destClusterIds.length)) {
            $ioAlert.show('', 'You must select destination business units.', 'error');
        } else if ($scope.cloneObj.destClusterIds.indexOf($scope.cloneObj.sourceClusterId) > 0) {
            $ioAlert.show('', 'Destination business unit must be different from the source business unit.', 'error');
        } else if (cloneForm.$valid) {
            $modalInstance.close($scope.cloneObj);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    $scope.tagHandler = function() {
        return null;
    }
}

CommentModalController.$inject = ['$scope', '$modalInstance', 'data', 'FormService'];

function CommentModalController($scope, $modalInstance, data, FormService) {
    $scope.type = 'comment';
    $scope.model = {};
    $scope.schema = {};
    $scope.titleText = data.titleText;
    $scope.buttonText = data.buttonText;
    $scope.commentForm = [];

    // Dynamic form
    FormService.buildDynamicFormSchema($scope.schema, {}, []);
    FormService.addCommentSchema($scope.schema);
    FormService.buildDynamicForm($scope.model, $scope.commentForm, {},{}, {},[], [], false);

    $scope.commentForm.push(FormService.getCommentInputSection('commentModal', false));

    $scope.postComment = function(commentForm) {
        if (commentForm.$valid) {
            $modalInstance.close($scope.model.comment);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

OrderWatchersListModalController.$inject = ['$scope', '$modalInstance', 'data','$rootScope'];

function OrderWatchersListModalController($scope, $modalInstance, data,$rs) {
    $scope.type = 'orderWatchersListModel';
    var orderWatchers = data.orderWatchers;
    $scope.users = data.users;
    $scope.modalObj = {};

    if (orderWatchers) {
        $scope.modalObj.selectedUsers = [];
        _.each(orderWatchers, function (watcherObj) {
            var userObj = _.find($scope.users, {id: watcherObj.user_id});
            var selUserObj = _.find($scope.modalObj.selectedUsers, {id: watcherObj.user_id});
            if(!selUserObj && userObj){
                $scope.modalObj.selectedUsers.push(userObj);
            }
        });
    }

    $scope.ok = function() {
        $modalInstance.close($scope.modalObj);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };

    $scope.tagHandler = function() {
        return null;
    }
}

AddCreativeLibraryModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddCreativeLibraryModalController($scope, $modalInstance, data) {

    $scope.type = 'creativeLibrary';
    $scope.modalObj = {};
    $scope.selectedImages = [];
    $scope.thirdPartyCreatives = [];
    $scope.media = {};
    $scope.library = false;
    $scope.clientId = data.clientId;
    $scope.fromPage = "lineitems";
    $scope.returnModal = data.model;

    $scope.ok = function() {
        $scope.modalObj = {
            "selectedImages": $scope.selectedImages,
            "media": $scope.media.images,
            "library": $scope.library,
            "thirdPartyCreatives": $scope.thirdPartyCreatives
        };
        $scope.thirdPartyCreatives = data.thirdPartyCreatives;
        $modalInstance.close($scope.modalObj);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

AddCreativesFacebookModalController.$inject = ['$scope', '$modalInstance', 'data'];

function AddCreativesFacebookModalController($scope, $modalInstance, self) {

    $scope.type = 'creativeLibraryFb';
    $scope.modalObj = {};
    $scope.selectedImages = [];
    $scope.media = {};
    $scope.library = false;
    $scope.clientId = self.clientId;
    $scope.returnModal = self.fbAdTypeObj.uploadedCreatives;
    $scope.isMultiple = self.fbAdTypeObj.adType == 'Single Image Ad' ? false : true;

    $scope.ok = function() {
        $scope.modalObj = {
            "selectedImages": $scope.selectedImages,
            "media": $scope.media.images,
            "library": $scope.library
        };
        $modalInstance.close($scope.modalObj);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

CreativeToLineItemModalController.$inject = ['$scope', 'OrdersService', '$ioAlert', '$modalInstance', 'data', 'creativesService'];

function CreativeToLineItemModalController($scope, OrdersService, $ioAlert, $modalInstance, data, creativesService) {
    $scope.orders = [];
    $scope.lineItemsObj = {};
    $scope.creative = data.creative;

    var getOrders = function() {
        OrdersService.getOrderForClient($scope.creative.client_id).then(function(success) {
            $scope.orders = success;
            $scope.hasNoOrders = ($scope.orders.length == 0);
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.toggle = function(ev, order) {
        $(ev.target).siblings(':last').slideToggle(200);
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $scope.lineItemsObj[order.id] = [];
            OrdersService.getLineItems(order.id).then(function() {
                $scope.lineItemsObj[order.id] = OrdersService.lineItems;
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else {
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
        }
    };

    $scope.attachCreatives = function(type, id) {
        if (type == 'order') {
            var obj = {
                "creativeId": $scope.creative.id,
                "orderId": id
            };
            creativesService.assignToOrder(obj).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error!', response.errors[i], 'error');
                    }
                } else {
                    $ioAlert.show('SUCCESS!', 'Creative attached Successfully.', 'success');
                    $modalInstance.close();
                }
            }, function() {
                $ioAlert.show('ERROR!', 'Attaching creative failed. Please try again later.', 'error');
            });

        } else if (type == 'lineitem') {
            var obj = {
                "creativeId": $scope.creative.id,
                "lineItemId": id
            };
            creativesService.assignToLineItem(obj).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error!', response.errors[i], 'error');
                    }
                } else {
                    $ioAlert.show('SUCCESS!', 'Creative attached Successfully.', 'success');
                    $modalInstance.close();
                }
            }, function() {
                $ioAlert.show('ERROR!', 'Attaching creative failed. Please try again later.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Please select order or line item to attach', 'error');
        }
    };

    if ($scope.creative) {
        getOrders();
    } else {
        $ioAlert.show('Error!', 'Please select creative to attach', 'error');
    }
}

// Modal Controller to handle Pixel Association
PixelToLineItemModalController.$inject = ['$scope', 'OrdersService', '$ioAlert', '$modalInstance', 'data', 'pixelsService', 'ClusterService'];

function PixelToLineItemModalController($scope, OrdersService, $ioAlert, $modalInstance, data, pixelsService, ClusterService) {
    $scope.orders = [];
    $scope.pixel = data.pixel;

    var getOrders = function () {
        var params = {
            "serviceId": $scope.pixel.pixel_service_id
        };
        pixelsService.getOrdersByServiceId(params).then(function (success) {
            $scope.orders = success;
            $scope.hasNoOrders = ($scope.orders.length == 0);
        }, function (error) {
            $ioAlert.show('ERROR!', 'Could not get Pixels.', 'error');
        });
    };

    $scope.showLineitems = function (ev, order, index) {
        var params = {
            "serviceId": $scope.pixel.pixel_service_id,
            "orderId": order.order_id
        };
        $(ev.target).siblings(':last').slideToggle(200);
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            pixelsService.getLineItemsByServiceAndOrderId(params).then(function (success) {
                $scope.orders[index].lineItems = success;
                for (var i = 0; i < $scope.orders[index].lineItems.length; i++) {
                    if ($scope.orders[index].lineItems[i].pixel_id) {
                        $scope.orders[index].lineItems[i].is_associated = true;
                    } else {
                        $scope.orders[index].lineItems[i].is_associated = false;
                    }
                }
            }, function () {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else {
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
        }
    };

    $scope.associatePixels = function (type, item) {
        if (type == 'lineitem') {
            var obj = {
                "pixelData": {
                    "lineItemIds": [item.line_item_id],
                    "clientId": $scope.pixel.client_id,
                    "serviceId": $scope.pixel.pixel_service_id,
                    "clusterId": $scope.pixel.cluster_id,
                    "pixelId": $scope.pixel.id
                }
            };
            pixelsService.associatePixelToLineItem(obj).then(function (response) {
                if (response.values) {
                    for (var i = 0; i < response.values.length; i++) {
                        if (response.values[i].is_associated) {
                            item.is_associated = true;
                        }
                    }
                }
                if (angular.isString(response.errors)) {
                    $ioAlert.show('ERROR!', response.errors, 'error');
                } else if(angular.isObject(response.errors)) {
                    $ioAlert.show('ERROR!', response.errors.Error, 'error');
                } else if (angular.isArray(response.errors)) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                } else {
                    $ioAlert.show('SUCCESS!', 'Pixel associated Successfully.', 'success');
                }
            }, function () {
                $ioAlert.show('ERROR!', 'Attaching association failed. Please try again later.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Please select line item to attach', 'error');
        }
    };

    if ($scope.pixel) {
        getOrders();
    } else {
        $ioAlert.show('ERROR!', 'Please select pixel to associate', 'error');
    }
}

AddCreativeModalController.$inject = ['$scope', '$modalInstance', 'data', 'MediaService', '$ioAlert'];

function AddCreativeModalController($scope, $modalInstance, data, MediaService, $ioAlert) {

    $scope.type = 'addCreative';
    $scope.customerId = data.customerId;
    $scope.creativeObj = {};

    $scope.ok = function() {
        for (var i = 0; i < $scope.creativeObj.creatives.length; i++) {
            MediaService.saveClientCreative($scope.customerId, $scope.creativeObj.creatives[i]).then(function() {
                if (MediaService.creative) {
                    $ioAlert.show('', 'File uploaded successfully.', 'success');
                } else if (MediaService.errors) {
                    for (var x = 0; x < MediaService.errors.length; x++) {
                        var message = MediaService.errors[x];
                        $ioAlert.show("", "File upload error: " + message, 'error');
                    }
                } else {
                    $ioAlert.show("Error!", "An error occurred uploading the file.", 'error');
                }
            }, function() {
                $ioAlert.show("Error!", "An error occurred uploading the file.", 'error');
            });
        }
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

FindIdsModalController.$inject = ['$scope', '$modalInstance', 'data', 'MediaService', '$ioAlert'];

function FindIdsModalController($scope, $modalInstance, data, MediaService, $ioAlert) {

    $scope.type = 'addCreative';
    $scope.customerId = data.customerId;
    $scope.creativeObj = {};
    $scope.find = ["Order IDs","Line Items IDs","Tasks IDs"];
    $scope.templates = [{ colId: 'col1', type: '', condition: '', solution: '', isDisabled: true, isNotSaved: true, isEditable: true, isAdd: true }];
    $scope.addEditProductFields = function (index) {
        for (var i = 0; i < $scope.templates.length; i++) {
            if (index == i) {
                $scope.templates[index].isDisabled = false;
            } else {
                $scope.templates[i].isDisabled = true;
            }
        }
        //$scope.disabled[$scope.templates[index].field_name] = false;
        $scope.tempobj = angular.copy($scope.templates[index]);

    }

    $scope.addSaveFields = function (index, template) {
        $scope.templates[index].isthere = true;
                template.isNotSaved = false;
                template.isDisabled = true;
                template.isAdd = false;
    }

    $scope.addGotodisable = function (index) {
        if ($scope.tempobj.type != "") {
            $scope.templates[index].type = $scope.tempobj.type;
            $scope.templates[index].condition = $scope.tempobj.condition;
            $scope.templates[index].solution = $scope.tempobj.solution;
            $scope.templates[index].isDisabled = true;
            $scope.templates[index].isNotSaved = false;
            $scope.template[index].isAdd = true;
            if ($scope.templates[index].isthere == true) {
                $scope.disabled[$scope.templates[index].type] = true;
            }
        } else {
            $scope.templates[index].type = "";
            $scope.templates[index].condition = "";
            $scope.templates[index].solution = "";
            $scope.templates[index].isDisabled = true;
        }
    }

    $scope.addDeleteTemplate = function (index) {
        if ($scope.templates[index].field_name == "") {
            $scope.templates.splice(index, 1);
        } else {
            $scope.templates.splice(index, 1);
                    if ($scope.templates.length == 0) {
                        $scope.templates = [{ colId: 'col1', type: '', condition: '', solution: '', isDisabled: true, isNotSaved: true, isEditable: true ,isAdd: true }];
                    }
        }
    }

    $scope.addNewTemplate = function () {
        var newItemNo = $scope.templates.length + 1;
        $scope.templates.push({ colId: 'col' + newItemNo, product_field_id: '', field_name: '', data_type: '', input_type: '', isDisabled: true, isNotSaved: false, isEditable: true, isAdd: true });
    }
    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

ServiceMapperModalController.$inject = ['$scope', '$modalInstance', 'data', 'ClientMappingService', '$filter', '$ioAlert'];

function ServiceMapperModalController($scope, $modalInstance, data, ClientMappingService, $filter, $ioAlert) {

    $scope.type = 'serviceMapper';
    $scope.mapObj = {
        "clientName": data.clientId,
        "advertiser": {}
    };
    $scope.SelRemoteClients = [];
    $scope.RemoteClientsLoading = false;
    $scope.searchLoading = false;
    $scope.RemoteClientPage = 1;

    var getClientServiceAdvertiser = function() {
        var obj = {
            "clientId": data.clientId,
            "serviceId": data.serviceId
        };
        ClientMappingService.getClientServiceAdvertiser(obj).then(function(response) {
            if (response.clientServiceAdvertiser && !data.model) {
                $scope.mapObj.advertiser = response.clientServiceAdvertiser;
            }
        }, function() {
            $ioAlert.show('Error!', 'Could not get Client Service Advertiser.', 'error');
        });
    };

    var getCachedAdvertiser = function() {
        var obj = {
            "clientId": data.clientId,
            "serviceId": data.serviceId
        };
        ClientMappingService.getCachedAdvertiser(obj).then(function(response) {
            $scope.cachingClients = response.clientServiceAdvertisers;
            if (data.model) {
                for (var i = 0, len = $scope.cachingClients.length; i < len; i++) {
                    if ($scope.cachingClients[i].advertiser_id == data.model) {
                        $scope.mapObj.advertiser = $scope.cachingClients[i];
                        $scope.mapObj.cachedClient = $scope.cachingClients[i];
                        break;
                    }
                }
                if (Object.keys($scope.mapObj.advertiser).length == 0) {
                    $scope.getExternalAdvertiserInfo();
                }
            }
        }, function() {
            $ioAlert.show('Error!', 'Could not get Client Service Advertiser.', 'error');
        })
    };

    $scope.getExternalAdvertiserInfo = function() {
        var obj = {
            "advertiserId": data.model,
            "serviceId": data.serviceId
        };
        ClientMappingService.getExternalAdvertiserInfo(obj).then(function(response) {
            if (response.cachedServiceAdvertiser) {
                $scope.mapObj.advertiser = response.cachedServiceAdvertiser;
                $scope.mapObj.remoteClient = response.cachedServiceAdvertiser;
            }
        }, function() {
            $ioAlert.show('Error!', 'Getting external Advertiser.', 'error');
        });
    };

    $scope.refreshExternalAdvertisers = function() {
        var obj = {
            "clusterId": data.clusterId,
            "serviceId": data.serviceId
        };
        $scope.RemoteClientsLoading = true;
        ClientMappingService.externalAdvertisersRefreshCache(obj).then(function() {
            $scope.RemoteClientsLoading = false;
        }, function() {
            $scope.RemoteClientsLoading = false;
            $ioAlert.show('Error!', 'Could not get external Advertisers.', 'error');
        });
    };

    $scope.fetchRemoteClients = function($select, $event) {
        var text = $select.search;
        if (text.length >= 2) {
            if (!$event) {
                $scope.RemoteClientPage = 1;
                $scope.SelRemoteClients = [];
            } else {
                $event.stopPropagation();
                $event.preventDefault();
                $scope.RemoteClientPage++;
            }
            var obj = {
                "search": text,
                "serviceId": data.serviceId,
                "page": $scope.RemoteClientPage
            };
            ClientMappingService.getExternalAdvertisers(obj).then(function(response) {
                if (response.advertisers) {
                    for (var i = 0, len = response.advertisers.length; i < len; i++) {
                        $scope.SelRemoteClients.push({
                            advertiser_id: response.advertisers[i].id,
                            advertiser_name: response.advertisers[i].name
                        });
                    }
                } else {
                    $ioAlert.show('Error!', 'External client list not found for this business unit', 'error');
                }
                $scope.searchLoading = false;
            }, function() {
                $ioAlert.show('Error!', 'Could not get external Advertisers.', 'error');
            });
        }
    };

    $scope.refreshFunction = function(text) {
        if (text.length >= 2) {
            var obj = {
                "search": text,
                "serviceId": data.serviceId
            };
            ClientMappingService.getExternalAdvertisers(obj).then(function(response) {
                if (response.advertisers) {
                    $scope.SelRemoteClients = [];
                    for (var i = 0, len = response.advertisers.length; i < len; i++) {
                        $scope.SelRemoteClients.push({
                            advertiser_id: response.advertisers[i].id,
                            advertiser_name: response.advertisers[i].name
                        });
                    }
                } else {
                    $ioAlert.show('Error!', 'External client list not found for this cluster', 'error');
                }
                $scope.searchLoading = false;
            }, function() {
                $ioAlert.show('Error!', 'Could not get external Advertisers.', 'error');
            });
        } else {
            $scope.SelRemoteClients = [];
        }
    };

    $scope.tagHandler = function() {
        return null;
    };

    $scope.use = function(obj) {
        if (obj) {
            $scope.mapObj.advertiser = obj;
        }
    };

    $scope.ok = function() {
        if ($scope.mapObj.isDefault) {
            var obj = {
                "clientId": data.clientId,
                "serviceId": data.serviceId,
                "advertiserId": $scope.mapObj.advertiser.advertiser_id,
                "advertiserName": $scope.mapObj.advertiser.advertiser_name,
            };
            if ($scope.mapObj.advertiserId) {
                ClientMappingService.updateClientServiceAdvertiser(obj).then(function() {
                    $ioAlert.show('', 'Service Mapping updated Successfully', 'success');
                    $modalInstance.close($scope.mapObj.advertiser);
                }, function() {
                    $ioAlert.show('Error!', 'Could not update Client Service Advertiser.', 'error');
                });
            } else if ($scope.mapObj.advertiser.advertiser_id) {
                ClientMappingService.addClientServiceAdvertiser(obj).then(function() {
                    $ioAlert.show('', 'Service Mapping added Successfully', 'success');
                    $modalInstance.close($scope.mapObj.advertiser);
                }, function() {
                    $ioAlert.show('Error!', 'Could not add Client Service Advertiser.', 'error');
                });
            } else {
                $ioAlert.show('Error!', 'Please select atleast one client', 'error');
            }
        } else {
            $modalInstance.close($scope.mapObj.advertiser);
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };

    var init = function() {
        getClientServiceAdvertiser();
        getCachedAdvertiser();
    };
    init();
}

CreateFormTemplateModalController.$inject = ['$scope', '$modalInstance', 'data', 'ProductService', 'TaskService', '$ioAlert'];

function CreateFormTemplateModalController($scope, $modalInstance, data, ProductService, TaskService, $ioAlert) {

    $scope.type = 'createFormTemplate';
    $scope.customerId = data.customerId;
    $scope.creativeObj = {};
    $scope.currentStep = {};
    $scope.currentStep.type = "initial";
    $scope.headerText = "Form Template";
    $scope.templateTypes = data.templateTypes;
    $scope.isLast = false;
    $scope.templateObj = {};
    $scope.templateObj.clusterIds = [];
    $scope.clusterArr = data.clusters;
    $scope.fromTemplate = modalFromTemplateHtmlUrl;
    $scope.productTemplate = modalProductTemplateHtmlUrl;
    $scope.orderTemplate = modalOrderTemplateHtmlUrl;
    $scope.taskTemplate = modalTaskTemplateHtmlUrl;

    $scope.nextStep = function() {
        if ($scope.templateObj.type) {
            $scope.isLast = true;
            switch ($scope.templateObj.type) {
                case '1':
                    $scope.currentStep.type = "order";
                    $scope.headerText = "Create New Order Form";
                    getClusters();
                    break;
                case '2':
                    $scope.currentStep.type = "product";
                    $scope.headerText = "Create New Product Form";
                    break;
                case '3':
                    $scope.currentStep.type = "task";
                    $scope.headerText = "Create New Task Form";
                    getTasks();
                    break;
            }
            getTemplates($scope.templateObj.type);
        } else {
            $ioAlert.show('Error!', 'Please select at least one type', 'error');
        }
    };

    var getClusters = function() {
        console.log($scope.templateObj.type);
        ProductService.getClustersWithoutOrderForm().then(function(response) {
            if (response.clusters) {
                $scope.clusterArr = response.clusters;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.back = function() {
        $scope.isLast = false;
        $scope.currentStep.type = "initial";
    };

    var getTemplates = function(id) {
        ProductService.getTemplates(id).then(function(response) {
            $scope.templates = response;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var getTasks = function() {
        TaskService.getTasksWithoutTaskForm().then(function(response) {
            $scope.tasks = response;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
    * Handle BU's removal
    */
    $scope.handleOnRemovalProductBU = function(removedValue) {
        if(Array.isArray(removedValue) && removedValue.length){
        }else {
            $scope.clusterArr = data.clusters;
        }
    }

    $scope.handleOnSelectionProductBU = function(selectedValue) {
        _.each(selectedValue, function (val) {
            if(val == 0) {
                $scope.clusterArr = [];
                $scope.templateObj.clusterIds = [];
                $scope.templateObj.clusterIds.push(val);
            }
        });
    }

    $scope.handleClearProductBU = function() {
        $scope.templateObj.clusterIds = [];
    }

    $scope.ok = function() {
        var obj = {};
        switch ($scope.templateObj.type) {
            case '1':
                obj.referenceId = $scope.templateObj.referenceId;
                obj.templateId = $scope.templateObj.templateId;
                if (!obj.referenceId && obj.referenceId !== 0) {
                    $ioAlert.show('Error!', 'Please select cluster', 'error');
                    return false;
                }
                break;
            case '2':
                obj.name = $scope.templateObj.name;
                obj.clusterIds = $scope.templateObj.clusterIds;
                obj.templateId = $scope.templateObj.templateId;
                if (obj.clusterIds.length == 0) {
                    $ioAlert.show('Error!', 'Please select business unit', 'error');
                    return false;
                }
                if (!obj.name) {
                    $ioAlert.show('Error!', 'Please enter product name', 'error');
                    return false;
                }
                break;
            case '3':
                obj.referenceId = $scope.templateObj.taskId;
                obj.templateId = $scope.templateObj.templateId;
                if (!obj.referenceId && obj.referenceId !== 0) {
                    $ioAlert.show('Error!', 'Please select task', 'error');
                    return false;
                }
                break;
        }
        if (!obj.templateId) {
            $ioAlert.show('Error!', 'Please select template', 'error');
            return false;
        }
        ProductService.saveFormEntity(obj).then(function(data) {
            if(data.errors) {
                $ioAlert.show('', 'Failed to create the form', 'error');
            }else {
                $ioAlert.show('', 'Form created Successfully', 'success');
            }
            $modalInstance.close();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}


CreateWfTemplateModalController.$inject = ['$scope', '$modalInstance', 'data', 'WorkflowsService', '$ioAlert'];

function CreateWfTemplateModalController($scope, $modalInstance, data, WorkflowsService, $ioAlert) {

    $scope.type = 'createWfTemplate';
    $scope.customerId = data.customerId;
    $scope.creativeObj = {};
    $scope.currentStep = {};
    $scope.currentStep.type = "initial";
    $scope.headerText = "Workflow Template";
    $scope.workflowTypes = data.workflowTypes;
    $scope.isLast = false;
    $scope.templateObj = {};
    $scope.clusterArr = [];
    $scope.wfFromTemplate = modalWfFromTemplateHtmlUrl;
    $scope.wfProductTemplate = modalWfProductTemplateHtmlUrl;
    $scope.wfOrderTemplate = modalWfOrderTemplateHtmlUrl;
    $scope.nextStep = function() {
        if ($scope.templateObj.type) {
            $scope.isLast = true;
            switch ($scope.templateObj.type) {
                case '4':
                    $scope.currentStep.type = "order";
                    $scope.headerText = "Create New Order Workflow";
                    getClusters();
                    break;
                case '5':
                    $scope.currentStep.type = "product";
                    $scope.headerText = "Create New Product Workflow";
                    getProducts();
                    break;

            }
            getTemplates($scope.templateObj.type);
        } else {
            $ioAlert.show('Error!', 'Please select atleast one type', 'error');
        }
    };

    $scope.back = function() {
        $scope.isLast = false;
        $scope.currentStep.type = "initial";
    };

    var getClusters = function() {
        WorkflowsService.getClustersWithoutWf().then(function(response) {
            if (response.clusters) {
                $scope.clusterArr = response.clusters;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var getProducts = function() {
        WorkflowsService.getProductsWithoutWf().then(function(response) {
            $scope.products = response.products;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var getTemplates = function(id) {
        WorkflowsService.getWfTemplates(id).then(function(response) {
            if (angular.isArray(response)) {
                $scope.templates = response;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.ok = function() {
        var obj = {};
        obj.referenceId = $scope.templateObj.referenceId;
        obj.templateId = $scope.templateObj.templateId;
        if (!obj.referenceId) {
            $ioAlert.show('Error!', 'Please select reference Id', 'error');
            return false;
        }
        if (!obj.templateId) {
            $ioAlert.show('Error!', 'Please select template', 'error');
            return false;
        }
        WorkflowsService.saveWFEntity(obj).then(function() {
            $ioAlert.show('', 'Workflow Template Created Successfully', 'success');
            $modalInstance.close();
        }, function(error) {
            $ioAlert.show('Error!', error, 'error');
        });
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}

CloneIntegrationTemplateModalController.$inject = ['$scope', '$modalInstance', 'data', 'ProductService', 'IntegrationsService', '$ioAlert'];

function CloneIntegrationTemplateModalController($scope, $modalInstance, data, ProductService, IntegrationsService, $ioAlert) {
    $scope.type = 'cloneIntegrationTemplate';
    $scope.currentStep = {};
    $scope.currentStep.type = "initial";
    $scope.headerText = "Clone Integration Template";
    $scope.templateTypes = data.templateTypes;
    $scope.integrations = data.integrations;
    $scope.products = [];
    $scope.isLast = false;
    $scope.templateObj = {};
    $scope.clusterArr = data.clusters;
    $scope.cloneTemplate = modalIntegrationsCloneTemplateHtmlUrl;
    $scope.orderCloneTemplate = modalIntegrationsOrderTemplateHtmlUrl;
    $scope.productCloneTemplate = modalIntegrationsProductTemplateHtmlUrl;

    $scope.nextStep = function() {
        if ($scope.templateObj.type) {
            $scope.isLast = true;
            switch ($scope.templateObj.type) {
                case '1':
                    $scope.currentStep.type = "product";
                    $scope.headerText = "Clone Product Integration Template";
                    getProducts();
                    break;
                case '2':
                    $scope.currentStep.type = "order";
                    $scope.headerText = "Clone Order Integration Template";
                    //getClusters();
                    break;
            }
        } else {
            $ioAlert.show('Error!', 'Please select atleast one type', 'error');
        }
    };

    $scope.back = function() {
        $scope.isLast = false;
        $scope.currentStep.type = "initial";
        $scope.headerText = "Clone Integration Template";
        $scope.templateObj = {};
    };

    var getProducts = function() {
        ProductService.getProducts().then(function() {
            $scope.products = ProductService.products;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.ok = function() {
        switch ($scope.templateObj.type) {
            case '1':
                if ($scope.templateObj.sourceProductId == $scope.templateObj.destProductId) {
                    $ioAlert.show('Error!', "source and destination products cannot be the same", 'error');
                } else {
                    IntegrationsService.cloneProductIntegrationTemplate($scope.templateObj).then(function(response) {
                        if (!response.errors) {
                            $ioAlert.show('', 'Product Integration Template Cloned Successfully', 'success');
                            $modalInstance.close();
                        } else if (response.errors.length > 0) {
                            for (var i = 0, len = response.errors.length; i < len; i++) {
                                $ioAlert.show('Error!', response.errors[i], 'error');
                            }
                        }
                    }, function() {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
                break;
            case '2':
                if ($scope.templateObj.sourceClusterId == $scope.templateObj.destClusterId) {
                    $ioAlert.show('Error!', "source and destination business units cannot be the same", 'error');
                } else {
                    IntegrationsService.cloneOrderIntegrationTemplate($scope.templateObj).then(function(response) {
                        if (!response.errors) {
                            $ioAlert.show('', 'Order Integration Template Cloned Successfully', 'success');
                            $modalInstance.close();
                        } else if (response.errors.length > 0) {
                            for (var i = 0, len = response.errors.length; i < len; i++) {
                                $ioAlert.show('Error!', response.errors[i], 'error');
                            }
                        }
                    }, function() {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
                break;
        }
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };
}



AddWatcherModalController.$inject = ['$scope', '$modalInstance', 'data','$rootScope'];

function AddWatcherModalController($scope, $modalInstance, data,$rs) {
    $scope.type = 'addWatchersList'; 
    var lineItemWatchers = data.lineItemWatchers;
    $scope.users = data.users;
    $scope.modalObj = {};
    
    if (lineItemWatchers) {
        $scope.modalObj.selectedUsers = [];
        _.each(lineItemWatchers, function (watcherObj) {
            var userObj = _.find($scope.users, {id: watcherObj.user_id});
            var selUserObj = _.find($scope.modalObj.selectedUsers, {id: watcherObj.user_id});
            if(!selUserObj && userObj){
                $scope.modalObj.selectedUsers.push(userObj);
            }
        });
    }

    $scope.ok = function() {
        $modalInstance.close($scope.modalObj);
    };

    $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
    };

    $scope.tagHandler = function() {
        return null;
    }
}

CreateNewFromModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert', 'ClusterService','$timeout'];

function CreateNewFromModalController($scope, $modalInstance, data, $ioAlert,ClusterService,$timeout) {
    $scope.type = 'createNewForm';
    var list = data.list;
    $scope.headerText = 'Create New Form';
    $scope.formObj = {};
    $scope.clusterArr = data.clusters;
    $scope.tasksList = data.tasksList;
    $scope.formListType = data.formListType.slice(1);
    if (list) {
        $scope.headerText = 'Update Form';
        $scope.formObj.id = list.id;
        $scope.formObj.name = list.name;
        $scope.formObj.contentTypeId = list.contentTypeId;
        $scope.formObj.clusterIds = list.clusterIds;
        $scope.formObj.isDefault = list.isDefault;
        $scope.formObj.taskIds = list.taskIds;
    }
    
    $scope.addNewForm = function(orderForm) {
        if (orderForm.$valid) {
            if ($scope.formObj) {
                $modalInstance.close($scope.formObj);
            } else {
                $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
            }
        } else {
            $ioAlert.show('Error!', 'Please fill all the required fields', 'error');
        }
    };

    // /*
    // * Handle BU's removal
    // */
    // $scope.handleOnRemovalBusinessUnit = function(removedValue) {
    //     if(Array.isArray(removedValue) && removedValue.length){
    //     }else {
    //         $scope.clusterArr = data.clusters;
    //     }
    // }
    //
    // $scope.handleOnSelectionBusinessUnit = function(selectedValue) {
    //     _.each(selectedValue, function (val) {
    //         if(val == 0) {
    //             $scope.clusterArr = [];
    //             $scope.formObj.clusterIds = [];
    //             $scope.formObj.clusterIds.push(val);
    //         }
    //     });
    // }

    $scope.selectAllClusters = function() {
        $scope.formObj.clusterIds = [];
        for (var j = 0, size = $scope.clusterArr.length; j < size; j++) {
            $scope.formObj.clusterIds.push($scope.clusterArr[j].id);
        }
    };

    $scope.handleClearBusinessUnit = function() {
        $scope.formObj.clusterIds = [];
    }

    $scope.handleClearTask = function() {
        $scope.formObj.taskIds = [];
    }

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

ForceAddOrUpdateFormModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert'];

function ForceAddOrUpdateFormModalController($scope, $modalInstance, data, $ioAlert) {
    $scope.type = 'forceAddOrUpdateForm';
    $scope.messages = data.errors;
    $scope.headerText = 'Confirm Operation';

    $scope.forceUpdate = function() {
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

ForceAddOrUpdateFormFieldModalController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert'];

function ForceAddOrUpdateFormFieldModalController($scope, $modalInstance, data, $ioAlert) {
    $scope.type = 'forceAddOrUpdateFormField';
    $scope.message = data.message;
    $scope.numAffectedFields = data.numAffectedFields;
    $scope.headerText = 'Confirm Operation';

    $scope.forceUpdate = function() {
        $modalInstance.close();
    };

    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

PackageSetDefaultController.$inject = ['$scope', '$modalInstance', 'data', '$ioAlert', 'PackagesService','$timeout','$filter','FormService','ClusterService','ProductService','OrdersService'];

function PackageSetDefaultController($scope,$modalInstance, data, $ioAlert, PackagesService, $timeout, $filter, FormService, ClusterService, ProductService,OrdersService) {
    $scope.inputType = data.input_type;
    var AD_UNITS_LIMIT = 25;
    var browserCount = 0;
    var langCount = 0;
    var osCount = 0;
    var dmCount = 0;
    var DFP_VALUES_LIMIT = 40;
    var geoLocationsCount = 0;
    var bandwidthCount = 0;
    var mobileCarrierCount = 0;

    $scope.init = function () {
        if ($scope.inputType == "device-capability") {
            $scope.contentKey = "dfp_device_capability";
            $scope.deviceCapabilities = [];
            $scope.devicesWidget = [];
            $scope.capabilitiesIncluded = [];
            $scope.capabilitiesExcluded = [];
            $scope.selectedData = [];
            PackagesService.getlookupcontents($scope.contentKey).then(function (response) {
                var res = response.data.lookupContents;
                _.each(res, function (content) {
                    var capability = {};
                    capability.id = content.id;
                    capability.name = content.lookup_value;
                    capability.criteria = "";
                    capability.criteria_link = "include";
                    $scope.deviceCapabilities.push(capability);
                })
                processCapabilitiesData('dfp_device_capability');
            }, function (error) {
                console.log("error loading Package keys");
            });
        }
        else if ($scope.inputType == "dfp_ad_units") {
            $scope.contentKey = "dfp_ad_units";
            $scope.adUnitsSearch = "";
            $scope.selectedAdUnits = [];
            $scope.adUnitsList = [];
            $scope.setOfAdUnitsList = [];
            $scope.adUnitsIncluded = [];
            $scope.adUnitsExcluded = [];
            $scope.previousAdunitsList = [];
            $scope.searchAdUnitsList = [];
            $scope.adUnitsRecHtmlUrl = adUnitsRecTempHtmlUrl;

            ProductService.getAdunitsByContentKey({ type: 'dfp_ad_unit', cluster_id: $scope.clusterId }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var adUnit = {};
                        adUnit.valueId = content.valueId;
                        adUnit.name = content.name;
                        adUnit.criteria = "";
                        adUnit.criteria_link = "include";
                        $scope.setOfAdUnitsList.push(adUnit);
                    })
                    $scope.adUnitsList = $scope.setOfAdUnitsList.slice(0, AD_UNITS_LIMIT);
                    $scope.previousAdunitsList = angular.copy($scope.adUnitsList);
                    //self.loadMore();
                    $scope.selectedAdUnits = data.field_values ? JSON.parse(data.field_values) : [];
                        _.each($scope.setOfAdUnitsList, function (category) {
                            _.each($scope.selectedAdUnits, function (unit) {
                                if (unit.valueId == category.valueId) {
                                    category.criteria = unit.criteria;
                                    category.criteria_link = unit.criteria_link;
                                }
                            })
                        })
                }
            }, function (error) { });
        }
        else if ($scope.inputType == "geo-location") {
            $scope.rootLocation = { "id": 0, "children": "1", "criteria": "" };
            $scope.navLocations = [];
            $scope.geolocSearch = "";
            $scope.collectedNodes = [0];
            $scope.includeOrExcludeLocation = null;
            var geoLocationsCount = 0;

            $scope.selectedInput = {
                value: 'locations'
            }
            $scope.geoTextInputs = {
                inputValues: ''
            }
            $scope.textInputOptions = ["US Postal Codes", "US States"];
            $scope.textInputObj = {
                textInputType: "US Postal Codes"
            }
            $scope.selectedCriteria = {
                criteria: ""
            };
            $scope.criteria = ["include all", "exclude all"];
            $scope.showError = false;
            $scope.selectedGeoLocations = (angular.isString(data.field_values) && data.field_values!=="" ) ? JSON.parse(data.field_values) : { selLocationPickers: [], selTextInputs: [] };
            getLocations();
        }
        else if ($scope.inputType == 'devices') {
            $scope.deviceSearch = "";
            $scope.browserSearch = "";
            $scope.browserLanguageSearch = "";
            $scope.OSSearch = "";
            $scope.manufacturerSearch = "";
            $scope.contentKeys = ['dfp_device_categories', 'dfp_browsers', 'dfp_browser_languages', 'dfp_operating_systems', 'dfp_device_manufacturers'];
            $scope.deviceCategories = [];
            $scope.devicesWidget = [];
            $scope.includeOrExcludeBrowser = null;
            $scope.includeOrExcludeBL = null;
            $scope.includeOrExcludeOS = null;
            $scope.includeOrExcludeDM = null;
            $scope.selectedData = data.field_values ? JSON.parse(data.field_values) : {};
            $scope.browsers = [];
            $scope.browserLanguages = [];
            $scope.operatingSystems = [];
            $scope.deviceManufacturers = [];
            $scope.catogeriesIncluded = [];
            $scope.catogeriesExcluded = [];
            $scope.selectedDeviceCategories = $scope.selectedData.deviceCategories ? $scope.selectedData.deviceCategories : [];
            $scope.selectedBrowsers = $scope.selectedData.browsers ? $scope.selectedData.browsers : [];
            $scope.selectedLanguages = $scope.selectedData.browserLanguages ? $scope.selectedData.browserLanguages : [];
            $scope.selectedOperatingSystems = $scope.selectedData.operatingSystems ? $scope.selectedData.operatingSystems : [];
            $scope.selectedDeviceManufacturers = $scope.selectedData.deviceManufacturers ? $scope.selectedData.deviceManufacturers : [];
            $scope.getDevicesByContentKey();
        }
        else if ($scope.inputType == 'DFP') {
            $scope.keySelected = false;
            $scope.presetText = '';
            $scope.valuesList = [];
            $scope.keyValuesArray = [];
            $scope.showSelectKey = true;
            $scope.showKeyValueGroup = false;
            $scope.lookup_content = [];
            $scope.keyValueBind = [];
            $scope.presetClass = '';
            $scope.setOfDfpValuesList = [];
            $scope.searchDfpValues = [];
            $scope.setOfValuesList = [];
            $scope.conditionText = [
                "is",
                "is not"
            ];
            $scope.sets = data.field_values ? JSON.parse(data.field_values) : [[]];
            for(var i=0;i<$scope.sets.length;i++){
                for(var j=0;j<$scope.sets[i].length;j++){
                    $scope.keyValueBind.push($scope.sets[i][j].keyValue);
                }
            }
            $scope.showKeyValueGroup = true;
            $scope.presetClass = 'preset-list-add';
            $scope.getKeys();
            $scope.hasMoreValues = true;
        }
        else if ($scope.inputType == 'connection') {
            $scope.bandwidthSearch = "";
            $scope.carrierSearch = "";
            $scope.connectionWidget = [];
            $scope.includeOrExcludeBandwidth = null;
            $scope.includeOrExcludeMobile = null;
            $scope.contentKeys = ['dfp_bandwidth_groups', 'dfp_mobile_carriers'];
            $scope.bandwidths = [];
            $scope.mobileCarriers = [];
            $scope.selectedConnections = data.field_values ? JSON.parse(data.field_values) : {};
            $scope.selectedConnections.bandwidths = $scope.selectedConnections.bandwidths ? $scope.selectedConnections.bandwidths : [];
            $scope.selectedConnections.mobileCarriers = $scope.selectedConnections.mobileCarriers ? $scope.selectedConnections.mobileCarriers : [];
            $scope.getConnectionsByContentKey();
        }
        else if ($scope.inputType == 'dfp-frequency'){
            $scope.unitTypes = ['Minutes','Hours', 'Days','Weeks','Months', 'Lifetime'];
            $scope.frequencySets = data.field_values ? JSON.parse(data.field_values) : [{impressions: null,durationUnits: null,unitType: ''}];
        }
    }

    var processCapabilitiesData = function (contentKey) {
        var capabilityList = [];
        var subList = [];
        $scope.selectedData = data.field_values ? JSON.parse(data.field_values) : { deviceCapabilities :[]};
        $scope.selectedData = $scope.selectedData.deviceCapabilities;
        if (($scope.selectedData && $scope.selectedData.length > 0)) {
            if (contentKey === 'dfp_device_capability') {
                capabilityList = $scope.deviceCapabilities;
                subList = $scope.selectedData;
                $scope.capabilitiesIncluded = _.filter($scope.selectedData, function (item) { return item.criteria == 'include'; });
                $scope.capabilitiesExcluded = _.filter($scope.selectedData, function (item) { return item.criteria == 'exclude'; });
            }
            processCapabilities(capabilityList, subList);
        }
    }

    var processCapabilities = function (totalList, subList) {
        _.each(totalList, function (category) {
            _.each(subList, function (device) {
                if (device.id == category.id) {
                    category.criteria = device.criteria;
                    category.criteria_link = device.criteria_link;
                }
            })
        })
    }

    $scope.toggleComponent = function (selectedOption) {
        $scope.selectedInput.value = selectedOption;
    }

    $scope.validateInputValues = function () {
        if ($scope.textInputObj.textInputType == "US Postal Codes") {
            var geoValues = $scope.geoTextInputs.inputValues.split(/,| |\n/);
            var filteredValues = geoValues.filter(function (el) {
                return el != "";
            });
            FormService.validatePostalCodes(filteredValues).then(function (success) {
                if (success) {
                    processTextInputs(success.data);
                }
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else if ($scope.textInputObj.textInputType == "US States") {
            var geoValues = $scope.geoTextInputs.inputValues.split(/,|\n/);
            var filteredValues = [];
            _.each(geoValues, function (geoValue) {
                if (geoValue !== "") {
                    var trimmedValue = geoValue.trim();
                    filteredValues.push(trimmedValue);
                }
            })
            FormService.validateUSStates(filteredValues).then(function (success) {
                if (success) {
                    processTextInputs(success.data);
                }
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    }


    $scope.addNewFrequencySet = function() {
        $scope.frequencySets.push(
            {
                impressions: null,
                durationUnits: null,
                unitType: ''

            }
        );
    }

    $scope.clearFrequencyKey = function(frequencyIndex) {
        $scope.frequencySets.splice(frequencyIndex, 1);
    }

    $scope.getLocationChilds = function (item) {
        if (item.children > 0) {
            $scope.navLocations = [];
            if ($scope.locations) {
                for (var i = 0, len = $scope.locations.length; i < len; i++) {
                    if ($scope.locations[i].parent_id == item.id) {
                        if ($scope.selectedGeoLocations.selLocationPickers.length > 0) {
                            var selIndex = _.findIndex($scope.selectedGeoLocations.selLocationPickers, { id: $scope.locations[i].id });
                            if (selIndex !== -1) {
                                $scope.locations[i].criteria = $scope.selectedGeoLocations.selLocationPickers[selIndex].criteria;
                                $scope.includeOrExcludeLocation = $scope.selectedGeoLocations.selLocationPickers[selIndex].criteria + 'location';
                            }
                        } else {
                            $scope.locations[i].criteria = "";
                        }
                        if ($scope.locations[i].criteria.length == 0 && item.criteria.length > 0) {
                            $scope.locations[i].criteria = item.criteria;
                        }
                        $scope.locations[i].criteria_link = 'include';
                        if ($scope.locations[i].criteria == "include") {
                            $scope.locations[i].criteria_link = 'included';
                        } else if ($scope.locations[i].criteria == "exclude") {
                            $scope.locations[i].criteria_link = 'excluded';
                        }
                        $scope.navLocations.push($scope.locations[i]);
                    }
                }
            }
            $scope.breadcrumbs = [];
            $scope.buildBreadcrumbs(item);
        }
    }

    $scope.getChildrenNodes = function (item) {
        if (item.children > 0) {
            if ($scope.collectedNodes.indexOf(item.id) < 0) {
                PackagesService.getlocationData(item.id).then(function (success) {
                    $scope.collectedNodes.push(item.id);
                    $scope.locations = $scope.locations.concat(success.data.locations);
                    $scope.getLocationChilds(item);
                    $scope.geolocSearch = "";
                }, function (error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                $scope.getLocationChilds(item);
            }
        }
    };

    $scope.buildFullName = function (item) {
        if (item.parent_id == 0) {
            return item.name + ".";
        } else {
            var obj = _.find($scope.locations, function (loc) {
                return loc.id == item.parent_id
            });
            return item.name + ", " + $scope.buildFullName(obj);
        }
    }

    function changeAllChildCriteria(parentId, criteria = "") {
        _.each($scope.locations, function (location) {
            if (location.parent_id == parentId) {
                if (criteria == "include") {
                    location.criteria = 'include';
                    location.criteria_link = 'included';
                } else if (criteria == "exclude") {
                    location.criteria = 'exclude';
                    location.criteria_link = 'excluded';
                } else {
                    location.criteria = '';
                    location.criteria_link = 'include';
                }
                changeAllChildCriteria(location.id, location.criteria);
            }
        });
    }

    $scope.buildBreadcrumbs = function (item) {
        if (item.parent_id) {
            $scope.breadcrumbs.unshift(item);
            if (item.parent_id == 0) {
                return false;
            } else {
                var obj = _.find($scope.locations, function (loc) {
                    return loc.id == item.parent_id
                });
                $scope.buildBreadcrumbs(obj);
            }
        }
    }

    var getLocations = function () {
        PackagesService.getlocationData(0).then(function (success) {
            $scope.locations = success.data.locations;
            $scope.getLocationChilds($scope.rootLocation);
        }, function (error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.getKeys = function() {
        PackagesService.getlookupcontents(data.content_key).then(function(success) {
                if(success.data  && success.data.lookupContents && success.data.lookupContents.length  > 0){
                    success.data.lookupContents.forEach(function(lookups){
                        $scope.lookup_content.push(lookups);
                    });
                }                    
        }, function(error) {
                console.log("error getting keys");
        });
    }

    $scope.addNewKey = function(setIndex) {
        $scope.sets[setIndex].push({
            keyId: null,
            keyValue: null,
            values: [],
            condition: 'is'
        })
    }

    $scope.addNewSet = function(){
        $scope.sets.push([]);
    }

    $scope.clearKey = function(setIndex, keyIndex) {
        $scope.keyValueBind.splice(keyIndex,1);
        $scope.sets[setIndex].splice(keyIndex, 1);
    }

    $scope.loadKeyValues = function(val, keyValueObj, selectObj){
        if(selectObj.search && selectObj.search.length > 0 && $scope.searchDfpValues && $scope.searchDfpValues.length > 0) {
            $scope.valuesList = $scope.searchDfpValues.slice(0, DFP_VALUES_LIMIT);
            $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
        } else {
            var dfpObj = $scope.setOfDfpValuesList.find(function(element) { 
                return  val == element.key; 
            }); 
            if(dfpObj) {
                $scope.setOfValuesList = dfpObj.values;
                $scope.valuesList = $scope.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
            } else {
                var obj = $scope.lookup_content.find(function(element) { 
                    return val == element.lookup_value; 
                }); 
                keyValueObj.isValuesLoaded = true;
                if($scope.keyValueBind.indexOf(val) !== -1){
    
                } else {
                    $scope.keyValueBind.push(val);
                }
    
                if(obj) {
                    keyValueObj.keyId = obj.id;
                    var searchKey = '';
                    OrdersService.getDfpValuesByKey(obj.id, searchKey).then(function(data) {
                        if(OrdersService.dfpValues) {
                            var dfpKeyValuesObj = {};
                            dfpKeyValuesObj.key = val;
                            dfpKeyValuesObj.values = OrdersService.dfpValues;
                            $scope.setOfDfpValuesList.push(dfpKeyValuesObj);
                            $scope.setOfValuesList = OrdersService.dfpValues;
                            $scope.valuesList = $scope.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                            $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
                            keyValueObj.isValuesLoaded = false;
                        }
                    }, function() {
                        console.log("Error getting dfp values for key ");
                    }); 
                }
            }
        }            
    }

    $scope.loadSearchResults = function(keyValueObj, selectObj) {
        keyValueObj.isValuesLoaded = true;
        if(selectObj.search && selectObj.search.length >= 3) {
            var obj = $scope.lookup_content.find(function(element) { 
                return keyValueObj.keyValue == element.lookup_value; 
            }); 
            OrdersService.getDfpValuesByKey(obj.id, selectObj.search).then(function(data) {
                if(OrdersService.dfpValues) {
                    $scope.searchDfpValues = OrdersService.dfpValues;
                    $scope.valuesList = $scope.searchDfpValues.slice(0, DFP_VALUES_LIMIT);
                    $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
                    keyValueObj.isValuesLoaded = false;
                }
            }, function() {
                console.log("Error getting dfp values for key ");
            }); 
        } else if(selectObj.search.length < 3 || selectObj.search == ''){
            var dfpObj = $scope.setOfDfpValuesList.find(function(element) { 
                return  keyValueObj.keyValue == element.key; 
            }); 
            if(dfpObj) {
                $scope.setOfValuesList = dfpObj.values;
                $scope.valuesList = $scope.setOfValuesList.slice(0, DFP_VALUES_LIMIT);
                $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
                keyValueObj.isValuesLoaded = false;  
            } 
        }   
    }

    $scope.loadMoreValues = function($event, searchKey) {
        $event.stopPropagation();
        $event.preventDefault();

        $scope.loading = true;

        if ($scope.valuesList) {
            let loadDfpValuesObj;
            if (searchKey.length >= 3) {
                loadDfpValuesObj = $scope.searchDfpValues.slice($scope.valuesList.length, $scope.valuesList.length + DFP_VALUES_LIMIT);
                $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
            } else {
                loadDfpValuesObj = $scope.setOfValuesList.slice($scope.valuesList.length, $scope.valuesList.length + DFP_VALUES_LIMIT);
                $scope.hasMoreValues = $scope.valuesList.length === DFP_VALUES_LIMIT;
            }
            $scope.valuesList = $scope.valuesList.concat(loadDfpValuesObj);
            $scope.hasMoreValues = loadDfpValuesObj.length === DFP_VALUES_LIMIT;
            $scope.loading = false;
        }
    };

    $scope.selectAllValues = function(keyValueObj){
        $scope.setOfDfpValuesList.forEach(function(valueObj){
            keyValueObj.values.push(valueObj);
        });
        keyValueObj.values = _.uniqBy(keyValueObj.values, 'id');
    }

    $scope.checkingCriteria = function () {
        for (var k = 0; k < $scope.selectedAdUnits.length; k++) {
            for (var j = 0; j < $scope.adUnitsList.length; j++) {
                if ($scope.selectedAdUnits[k].name == $scope.adUnitsList[j].name) {
                    if ($scope.selectedAdUnits[k].criteria == "include") {
                        $scope.adUnitsList[j].criteria = 'include';
                        $scope.adUnitsList[j].criteria_link = 'included';
                    } else if ($scope.selectedAdUnits[k].criteria == "exclude") {
                        $scope.adUnitsList[j].criteria = 'exclude';
                        $scope.adUnitsList[j].criteria_link = 'excluded';
                    } else {
                        $scope.adUnitsList[j].criteria = '';
                        $scope.adUnitsList[j].criteria_link = 'include';
                    }
                }
            }
        }
    }

    $scope.checkChildCriteria = function (adunit) {
        for (var k = 0; k < $scope.selectedAdUnits.length; k++) {
            for (var j = 0; j < adunit.childData.length; j++) {
                if ($scope.selectedAdUnits[k].name == adunit.childData[j].name) {
                    if ($scope.selectedAdUnits[k].criteria == "include") {
                        adunit.childData[j].criteria = 'include';
                        adunit.childData[j].criteria_link = 'included';
                    } else if ($scope.selectedAdUnits[k].criteria == "exclude") {
                        adunit.childData[j].criteria = 'exclude';
                        adunit.childData[j].criteria_link = 'excluded';
                    } else {
                        adunit.childData[j].criteria = '';
                        adunit.childData[j].criteria_link = 'include';
                    }
                }
            }
        }
    }


    $scope.getChildAdUnits = function (item, isExpanded, type) {
        var selectedCretiriaList = [];
        if (isExpanded && type == 'parent') {
            ProductService.getAdunitsByContentKey({ type: 'dfp_ad_unit', value_id: item.valueId, cluster_id: $scope.clusterId }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        if (content.hasChildren) {
                            $scope.childData = [];
                            var slectedID = content.valueId;
                            content.childData = _.toArray(content.childData);
                            _.each(content.childData, function (item) {
                                item.criteria = "";
                                item.criteria_link = "include";
                                $scope.childData.push(item);
                            })
                            $scope.setChlidDataDefaultCreteria(content);
                        }
                    })
                    _.each($scope.adUnitsList, function (adunit) {
                        if (adunit.valueId == success.data[0].valueId && success.data[0].hasChildren) {
                            adunit.childData = $scope.childData;
                            if (adunit.criteria_link == 'included') {
                                $scope.setChlidDataCreteriaInclude(adunit);
                            } else if (adunit.criteria_link == 'excluded') {
                                $scope.setChlidDataCreteriaExclude(adunit);
                            } else {
                                $scope.setChlidDataDefaultCreteria(adunit);
                            }
                            $scope.checkChildCriteria(adunit);
                        }
                    })
                }
            }, function (error) { });
        } else if (isExpanded && item.hasChildren) {
            item.childData = _.toArray(item.childData);
            var selectedParent = _.find($scope.adUnitsList, function (el) { return el.valueId == item.superParentId });
            if(item.showExclude || item.showInclude){
                if(selectedParent.criteria_link == 'included' || selectedParent.criteria_link == 'excluded'){
                    selectedCretiriaList.push(selectedParent.criteria_link);
                }
                if (item.criteria_link == 'included') {
                    $scope.setChlidDataCreteriaInclude(item);
                } else if (item.criteria_link == 'excluded') {
                    $scope.setChlidDataCreteriaExclude(item);
                } else {
                    if (selectedParent.childData && selectedParent.childData.length > 0) {
                        $scope.applyCriteria(selectedParent.childData, item, selectedCretiriaList);
                    }
                 }
            }
            $scope.checkChildCriteria(item);
        }
    }

    $scope.applyCriteria = function (childNodesList, item, selectedCretiriaList) {
        childNodesList.every(function (element) {
            if (element.criteria_link == 'included' || element.criteria_link == 'excluded') {
                selectedCretiriaList.push(element.criteria_link)
            } else {
                if (element.hasChildren && element.childData.length > 0 && element.name !== item.name) {
                    $scope.applyCriteria(element.childData, item, selectedCretiriaList);
                }
            }
        });
        if (selectedCretiriaList.length > 0) {
            if (selectedCretiriaList[0] == 'included') {
                $scope.setChlidDataCreteriaInclude(item);
            } else if (selectedCretiriaList[0] == 'excluded') {
                $scope.setChlidDataCreteriaExclude(item);
            }
        } else {
            $scope.setChlidDataDefaultCreteria(item);
        }
    }

    $scope.changeIncludeExclude = function (item, criteria, data, type) {
        if ($scope.inputType == "device-capability") {
            $scope.devicesWidget = data;
            var index = $scope.devicesWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    $scope.devicesWidget[index].criteria = 'include';
                    $scope.devicesWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    $scope.devicesWidget[index].criteria = 'exclude';
                    $scope.devicesWidget[index].criteria_link = 'excluded';
                } else {
                    $scope.devicesWidget[index].criteria = '';
                    $scope.devicesWidget[index].criteria_link = 'include';
                }
                if (type === 'capability') {
                    var selIndex = _.findIndex($scope.selectedData, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedData[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedData.push($scope.devicesWidget[index]);
                    }
                    $scope.capabilitiesIncluded = _.filter($scope.selectedData, function (item) { return item.criteria == 'include'; });
                    $scope.capabilitiesExcluded = _.filter($scope.selectedData, function (item) { return item.criteria == 'exclude'; });
                }
            }
        }
        else if ($scope.inputType == "dfp_ad_units") {
            if (data == 'childLevel') {
                var indexVal = type.childData.indexOf(item);
                if (indexVal >= 0) {
                    if (criteria == "include") {
                        type.childData[indexVal].criteria = 'include';
                        type.childData[indexVal].criteria_link = 'included';
                        $scope.removeIncludedChildNodes(item);
                        $scope.setChlidDataCreteriaInclude(item);
                    } else if (criteria == "exclude") {
                        type.childData[indexVal].criteria = 'exclude';
                        type.childData[indexVal].criteria_link = 'excluded';
                        $scope.removeChildNodesCriteria(item);
                        $scope.setChlidDataCreteriaExclude(item);
                    } else {
                        type.childData[indexVal].criteria = '';
                        type.childData[indexVal].criteria_link = 'include';
                    }
                    var selIndex = _.findIndex($scope.selectedAdUnits, { valueId: type.childData[indexVal].valueId });
                    if (selIndex >= 0) {
                        $scope.selectedAdUnits[selIndex] = type.childData[indexVal];
                    } else {
                        $scope.selectedAdUnits.push(type.childData[indexVal]);
                    }
                    $scope.adUnitsIncluded = _.filter($scope.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                    $scope.adUnitsExcluded = _.filter($scope.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                }
            } else {
                var index = $scope.adUnitsList.indexOf(item);
                if (index >= 0) {
                    if (criteria == "include") {
                        $scope.adUnitsList[index].criteria = 'include';
                        $scope.adUnitsList[index].criteria_link = 'included';
                        $scope.removeIncludedChildNodes(item);
                        $scope.setChlidDataCreteriaInclude(item);
                    } else if (criteria == "exclude") {
                        $scope.adUnitsList[index].criteria = 'exclude';
                        $scope.adUnitsList[index].criteria_link = 'excluded';
                        $scope.removeChildNodesCriteria(item);
                        $scope.setChlidDataCreteriaExclude(item);
                    } else {
                        $scope.adUnitsList[index].criteria = '';
                        $scope.adUnitsList[index].criteria_link = 'include';
                    }
                    var selIndex = _.findIndex($scope.selectedAdUnits, { valueId: $scope.adUnitsList[index].valueId });
                    if (selIndex >= 0) {
                        $scope.selectedAdUnits[selIndex] = $scope.adUnitsList[index];
                    } else {
                        $scope.selectedAdUnits.push($scope.adUnitsList[index]);
                    }
                    $scope.adUnitsIncluded = _.filter($scope.selectedAdUnits, function (item) { return item.criteria == 'include'; });
                    $scope.adUnitsExcluded = _.filter($scope.selectedAdUnits, function (item) { return item.criteria == 'exclude'; });
                }
            }
        }
        else if ($scope.inputType == 'devices') {
            $scope.devicesWidget = data;
            var index = $scope.devicesWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    $scope.devicesWidget[index].criteria = 'include';
                    $scope.devicesWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    $scope.devicesWidget[index].criteria = 'exclude';
                    $scope.devicesWidget[index].criteria_link = 'excluded';
                } else {
                    $scope.devicesWidget[index].criteria = '';
                    $scope.devicesWidget[index].criteria_link = 'include';
                }
                if (type === 'category') {
                    var selIndex = _.findIndex($scope.selectedDeviceCategories, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedDeviceCategories[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedDeviceCategories.push($scope.devicesWidget[index]);
                    }
                    $scope.catogeriesIncluded = _.filter($scope.selectedDeviceCategories, function (item) { return item.criteria == 'include'; });
                    $scope.catogeriesExcluded = _.filter($scope.selectedDeviceCategories, function (item) { return item.criteria == 'exclude'; });
                } else if (type === 'browser') {
                    if (browserCount < 1) {
                        $scope.includeOrExcludeBrowser = criteria + 'browser';
                    }
                    var selIndex = _.findIndex($scope.selectedBrowsers, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedBrowsers[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedBrowsers.push($scope.devicesWidget[index]);
                    }
                    browserCount++;
                } else if (type === 'browserLanguage') {
                    if (langCount < 1) {
                        $scope.includeOrExcludeBL = criteria + 'bl';
                    }
                    var selIndex = _.findIndex($scope.selectedLanguages, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedLanguages[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedLanguages.push($scope.devicesWidget[index]);
                    }
                    langCount++;
                } else if (type === 'deviceManufacture') {
                    if (dmCount < 1) {
                        $scope.includeOrExcludeDM = criteria + 'dm';
                    }
                    var selIndex = _.findIndex($scope.selectedDeviceManufacturers, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedDeviceManufacturers[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedDeviceManufacturers.push($scope.devicesWidget[index]);
                    }
                    dmCount++;
                } else {
                    if (osCount < 1) {
                        $scope.includeOrExcludeOS = criteria + 'os';
                    }
                    var selIndex = _.findIndex($scope.selectedOperatingSystems, { id: $scope.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedOperatingSystems[selIndex] = $scope.devicesWidget[index];
                    } else {
                        $scope.selectedOperatingSystems.push($scope.devicesWidget[index]);
                    }
                    osCount++;
                }

            }
        }
        else if ($scope.inputType == "geo-location") {
            var index = $scope.navLocations.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    $scope.navLocations[index].criteria = 'include';
                    $scope.navLocations[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    $scope.navLocations[index].criteria = 'exclude';
                    $scope.navLocations[index].criteria_link = 'excluded';
                } else {
                    $scope.navLocations[index].criteria = '';
                    $scope.navLocations[index].criteria_link = 'include';
                }
                if (geoLocationsCount < 1) {
                    $scope.includeOrExcludeLocation = criteria + 'location';
                }
                var selIndex = _.findIndex($scope.selectedGeoLocations.selLocationPickers, { id: $scope.navLocations[index].id });
                $scope.navLocations[index].full_name = $scope.buildFullName($scope.navLocations[index])
                if (selIndex >= 0) {
                    $scope.selectedGeoLocations.selLocationPickers[selIndex] = $scope.navLocations[index];
                } else {
                    $scope.selectedGeoLocations.selLocationPickers.push($scope.navLocations[index]);
                }
                changeAllChildCriteria($scope.navLocations[index].id, $scope.navLocations[index].criteria);
                for (var i = 0; i < $scope.selectedGeoLocations.selLocationPickers.length; i++) {
                    var parentId = parseInt($scope.selectedGeoLocations.selLocationPickers[i].parent_id);
                    var parentObj = _.find($scope.locations, { id: parentId });
                    if (parentObj && parentObj.criteria === $scope.selectedGeoLocations.selLocationPickers[i].criteria) {
                        $scope.selectedGeoLocations.selLocationPickers.splice(i, 1);
                    }
                }
                geoLocationsCount++;
            }
        }
        else if ($scope.inputType == 'connection') {
            $scope.connectionWidget = data;
            var index = $scope.connectionWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    $scope.connectionWidget[index].criteria = 'include';
                    $scope.connectionWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    $scope.connectionWidget[index].criteria = 'exclude';
                    $scope.connectionWidget[index].criteria_link = 'excluded';
                } else {
                    $scope.connectionWidget[index].criteria = '';
                    $scope.connectionWidget[index].criteria_link = 'include';
                }

                if (type === 'bandwidth') {
                    if (bandwidthCount < 1) {
                        $scope.includeOrExcludeBandwidth = criteria + 'bandwidth';
                    }
                    var selIndex = _.findIndex($scope.selectedConnections.bandwidths, { id: $scope.connectionWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedConnections.bandwidths[selIndex] = $scope.connectionWidget[index];
                    } else {
                        $scope.selectedConnections.bandwidths.push($scope.connectionWidget[index]);
                    }
                    bandwidthCount++;
                } else if (type === 'mobileCarrier') {
                    if (mobileCarrierCount < 1) {
                        $scope.includeOrExcludeMobile = criteria + 'carrier';
                    }
                    var selIndex = _.findIndex($scope.selectedConnections.mobileCarriers, { id: $scope.connectionWidget[index].id });
                    if (selIndex >= 0) {
                        $scope.selectedConnections.mobileCarriers[selIndex] = $scope.connectionWidget[index];
                    } else {
                        $scope.selectedConnections.mobileCarriers.push($scope.connectionWidget[index]);
                    }
                    mobileCarrierCount++;
                }
            }
        }

    }

    $scope.removeSelectedData = function (item, selectedWidgetData, WidgetData, type) {
        if ($scope.inputType == "device-capability") {
            var selIndex = selectedWidgetData.indexOf(item);
            if (selIndex >= 0) {
                selectedWidgetData.splice(selIndex, 1);
                var itemIndex;
                if (item.criteria == 'include') {
                    itemIndex = $scope.capabilitiesIncluded.indexOf(item);
                    $scope.capabilitiesIncluded.splice(itemIndex, 1);
                }
                else {
                    itemIndex = $scope.capabilitiesExcluded.indexOf(item);
                    $scope.capabilitiesExcluded.splice(itemIndex, 1);
                }
            }
            var index = _.findIndex(WidgetData, { id: item.id });
            if (index >= 0) {
                WidgetData[index].criteria = '';
                WidgetData[index].criteria_link = 'include';
            }
        }
        else if ($scope.inputType == "dfp_ad_units") {

            var selIndex = _.findIndex($scope.selectedAdUnits, { valueId: item.valueId });
            if (selIndex >= 0) {
                $scope.selectedAdUnits.splice(selIndex, 1);
                var itemIndex;
                if (item.criteria == 'include') {
                    itemIndex = $scope.adUnitsIncluded.indexOf(item);
                    $scope.adUnitsIncluded.splice(itemIndex, 1);
                }
                else {
                    itemIndex = $scope.adUnitsExcluded.indexOf(item);
                    $scope.adUnitsExcluded.splice(itemIndex, 1);
                }
            }
            var index = _.findIndex($scope.adUnitsList, { valueId: item.valueId });
            if (index >= 0) {
                $scope.adUnitsList[index].criteria = '';
                $scope.adUnitsList[index].criteria_link = 'include';
                if ($scope.adUnitsList[index].childData && $scope.adUnitsList[index].childData.length > 0) {
                    var selectedCretiriaList = [];
                    $scope.applyCriteria($scope.adUnitsList[index].childData, item, selectedCretiriaList);
                }
            } else {
                var parentIndex = _.findIndex($scope.adUnitsList, { valueId: item.superParentId });
                if(parentIndex >=0){
                    $scope.resetChildCriteria($scope.adUnitsList[parentIndex].childData,item);
                }
                if ($scope.adUnitsList[parentIndex].criteria_link == 'included') {
                    $scope.setChlidDataCreteriaInclude(item);
                } else if ($scope.adUnitsList[parentIndex].criteria_link == 'excluded') {
                    $scope.setChlidDataCreteriaExclude(item);
                } else {
                    var selectedCretiriaList = [];
                    $scope.applyCriteria($scope.adUnitsList[parentIndex].childData, item, selectedCretiriaList);
                }
            }
        }
        else if ($scope.inputType == "devices") {
            var selIndex = selectedWidgetData.indexOf(item);
            if (selIndex >= 0) {
                selectedWidgetData.splice(selIndex, 1);
                if (type == 'category') {
                    var itemIndex;
                    if (item.criteria == 'include') {
                        itemIndex = $scope.catogeriesIncluded.indexOf(item);
                        $scope.catogeriesIncluded.splice(itemIndex, 1);
                    }
                    else {
                        itemIndex = $scope.catogeriesExcluded.indexOf(item);
                        $scope.catogeriesExcluded.splice(itemIndex, 1);
                    }
                }
                if (selIndex === 0 && selectedWidgetData.length == 0) {
                    if (type === 'os') {
                        osCount = 0;
                        $scope.includeOrExcludeOS = null;
                    } else if (type === 'lang') {
                        langCount = 0;
                        $scope.includeOrExcludeBL = null;
                    } else if (type === 'browser') {
                        browserCount = 0;
                        $scope.includeOrExcludeBrowser = null;
                    } else if (type === 'deviceManufacture') {
                        dmCount = 0;
                        $scope.includeOrExcludeDM = null;
                    }
                }
            }
            var index = _.findIndex(WidgetData, { id: item.id });
            if (index >= 0) {
                WidgetData[index].criteria = '';
                WidgetData[index].criteria_link = 'include';
            }
        }
        else if ($scope.inputType == "geo-location") {
            var selIndex = $scope.selectedGeoLocations.selLocationPickers.indexOf(item);
            if (selIndex >= 0) {
                $scope.selectedGeoLocations.selLocationPickers.splice(selIndex, 1);
                if (selIndex === 0) {
                    geoLocationsCount = 0;
                    $scope.includeOrExcludeLocation = null;
                }
            }

            var parentId = parseInt(item.parent_id);
            var parentLocation = _.find($scope.locations, { id: parentId });
            var locationObj = _.find($scope.locations, { id: item.id });
            if (locationObj) {
                if (parentLocation) {
                    if (parentLocation.criteria == "include") {
                        locationObj.criteria = 'include';
                        locationObj.criteria_link = 'included';
                    } else if (parentLocation.criteria == "exclude") {
                        locationObj.criteria = 'exclude';
                        locationObj.criteria_link = 'excluded';
                    } else {
                        locationObj.criteria = '';
                        locationObj.criteria_link = 'include';
                    }
                } else {
                    locationObj.criteria = '';
                    locationObj.criteria_link = 'include';
                }
                changeAllChildCriteria(item.id, locationObj.criteria);
            }
            for (var i = 0; i < $scope.selectedGeoLocations.selLocationPickers.length; i++) {
                if ($scope.selectedGeoLocations.selLocationPickers[i].parent_id == String(item.id)) {
                    $scope.selectedGeoLocations.selLocationPickers.splice(i, 1);
                }
            }
        }
        else if ($scope.inputType == 'connection') {
            var selIndex = selectedWidgetData.indexOf(item);
            if (selIndex >= 0) {
                selectedWidgetData.splice(selIndex, 1);
                if (selIndex === 0 && selectedWidgetData.length == 0) {
                    if (type === 'bandwidth') {
                        bandwidthCount = 0;
                        $scope.includeOrExcludeBandwidth = null;
                    } else {
                        mobileCarrierCount = 0;
                        $scope.includeOrExcludeMobile = null;
                    }
                }
            }
            var index = _.findIndex(WidgetData, { id: item.id });
            if (index >= 0) {
                WidgetData[index].criteria = '';
                WidgetData[index].criteria_link = 'include';
            }
        }
    }

    $scope.resetChildCriteria = function(childData,item){
        _.each(childData,function(el,index){
            if(el.valueId == item.valueId){
                el.criteria = '';
                el.criteria_link = 'include';
            }
            if(el.childData && el.childData.length > 0){
                $scope.resetChildCriteria(el.childData,item);
            }
        })
    }

    $scope.clearSelectedChildNodes = function (item) {
        if (item.childData && item.childData.length > 0) {
            _.each(item.childData, function (childItem) {
                childItem.criteria = '';
                childItem.criteria_link = 'include';
                $scope.clearSelectedChildNodes(childItem);
            })
        }
    }

    var processTextInputs = function (response) {
        if (response.valid_geo_values && response.valid_geo_values.length > 0) {
            _.each(response.valid_geo_values, function (validGeoValue) {
                validGeoValue.geoType = $scope.textInputObj.textInputType;
                validGeoValue.criteria_link = 'included';
                $scope.selectedGeoLocations.selTextInputs.push(validGeoValue);
            })
            $scope.geoTextInputs.inputValues = '';
        }

        if (response.invalid_geo_values && response.invalid_geo_values.length > 0) {
            $scope.showError = true;
            $scope.geoTextInputs.inputValues = response.invalid_geo_values.toString();
        }
    }

    $scope.loadSearchUnits = function (adUnitsSearch) {
        if (event.keyCode == 13 && adUnitsSearch.length >= 3) {
            var params = {};
            if (isNaN(parseInt(adUnitsSearch))) {
                params = { type: 'dfp_ad_unit', search_criteria: adUnitsSearch, search_by: 'name', cluster_id: $scope.clusterId }
            } else {
                params = { type: 'dfp_ad_unit', search_criteria: parseInt(adUnitsSearch), search_by: 'valueId', cluster_id: $scope.clusterId }
            }
            ProductService.searchAdunitsByInput(params).then(function (success) {
                if (success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var adUnit = {};
                        adUnit.valueId = content.valueId;
                        adUnit.name = content.name;
                        adUnit.criteria = "";
                        adUnit.criteria_link = "include";
                        $scope.searchAdUnitsList.push(adUnit);
                    })
                    $scope.adUnitsList = $scope.searchAdUnitsList.slice(0, AD_UNITS_LIMIT);
                    $scope.checkingCriteria();
                }
            })
        } else if (event.keyCode == 8 && $scope.adUnitsSearch.length == 0) {
            $scope.searchAdUnitsList = [];
            $scope.adUnitsList = [];
            $scope.adUnitsList = angular.copy($scope.previousAdunitsList);
            $scope.checkingCriteria();
        }
    }

    $scope.loadMore = function () {
        document.getElementById("loadMore")
            .addEventListener('scroll', function (event) {
                if ((event.target.offsetHeight + event.target.scrollTop + 20) > event.target.scrollHeight) {
                    if ($scope.adUnitsSearch && $scope.adUnitsSearch.length > 0) {
                        var loadAdUnitsObj = $scope.searchAdUnitsList.slice($scope.adUnitsList.length, $scope.adUnitsList.length + AD_UNITS_LIMIT);
                        $scope.adUnitsList = $scope.adUnitsList.concat(loadAdUnitsObj);
                    } else {
                        var loadAdUnitsObj = $scope.setOfAdUnitsList.slice($scope.adUnitsList.length, $scope.adUnitsList.length + AD_UNITS_LIMIT);
                        $scope.adUnitsList = $scope.adUnitsList.concat(loadAdUnitsObj);
                    }
                    $scope.$apply();
                }
            });
    }

    $scope.getDevicesByContentKey = function () {
        _.each($scope.contentKeys, function (contentKey) {
            PackagesService.getlookupcontents(contentKey).then(function (success) {
                if (success.data && success.data.lookupContents && success.data.lookupContents.length > 0) {
                    _.each(success.data.lookupContents, function (content) {
                        var device = {};
                        device.id = content.id;
                        device.name = content.lookup_value;
                        device.criteria = "";
                        device.criteria_link = "include";
                        if (contentKey === 'dfp_device_categories') {
                            $scope.deviceCategories.push(device);
                            $scope.catogeriesIncluded = _.filter($scope.selectedDeviceCategories, function (item) { return item.criteria == 'include'; });
                            $scope.catogeriesExcluded = _.filter($scope.selectedDeviceCategories, function (item) { return item.criteria == 'exclude'; });
                        } else if (contentKey === 'dfp_browsers') {
                            $scope.browsers.push(device);
                        } else if (contentKey === 'dfp_browser_languages') {
                            $scope.browserLanguages.push(device);
                        } else if (contentKey === 'dfp_operating_systems') {
                            $scope.operatingSystems.push(device);
                        } else if (contentKey === 'dfp_device_manufacturers') {
                            $scope.deviceManufacturers.push(device);
                        }
                    })
                    processDevicesData(contentKey);
                }
            }, function (error) { });
        })
    }

    var processDevicesData = function (contentKey) {
        var deviceList = [];
        var subList = [];
        if (($scope.selectedDeviceCategories && $scope.selectedDeviceCategories.length > 0)
            || ($scope.selectedBrowsers && $scope.selectedBrowsers.length > 0)
            || ($scope.selectedLanguages && $scope.selectedLanguages.length > 0)
            || ($scope.selectedOperatingSystems && $scope.selectedOperatingSystems.length > 0)
            || ($scope.selectedDeviceManufacturers && $scope.selectedDeviceManufacturers.length > 0)) {
            if (contentKey === 'dfp_device_categories') {
                deviceList = $scope.deviceCategories;
                subList = $scope.selectedDeviceCategories;
            } else if (contentKey === 'dfp_browsers') {
                deviceList = $scope.browsers;
                subList = $scope.selectedBrowsers;
                $scope.includeOrExcludeBrowser = subList.length > 0 ? subList[0].criteria + 'browser' : null;
            } else if (contentKey === 'dfp_browser_languages') {
                deviceList = $scope.browserLanguages;
                subList = $scope.selectedLanguages;
                $scope.includeOrExcludeBL = subList.length > 0 ? subList[0].criteria + 'bl' : null;
            } else if (contentKey === 'dfp_operating_systems') {
                deviceList = $scope.operatingSystems;
                subList = $scope.selectedOperatingSystems;
                $scope.includeOrExcludeOS = subList.length > 0 ? subList[0].criteria + 'os' : null;
            } else if (contentKey === 'dfp_device_manufacturers') {
                deviceList = $scope.deviceManufacturers;
                subList = $scope.selectedDeviceManufacturers;
                $scope.includeOrExcludeDM = subList.length > 0 ? subList[0].criteria + 'dm' : null;
            }

            processCategories(deviceList, subList);
        }
    }

    $scope.clearSelectedData = function (type, devicesData) {
        if ($scope.inputType == 'devices') {
            if (type == "category") {
                $scope.selectedDeviceCategories = [];
                $scope.includeOrExcludeCategory = null;
                $scope.catogeriesExcluded = [];
                $scope.catogeriesIncluded = [];
            }
            else if (type == "browser") {
                $scope.selectedBrowsers = [];
                browserCount = 0;
                $scope.includeOrExcludeBrowser = null;
            }
            else if (type == "lang") {
                $scope.selectedLanguages = [];
                langCount = 0;
                $scope.includeOrExcludeBL = null;
            }
            else if (type == "os") {
                $scope.selectedOperatingSystems = [];
                osCount = 0;
                $scope.includeOrExcludeOS = null;
            }
            else if (type == "deviceManufacture") {
                $scope.selectedDeviceManufacturers = [];
                dmCount = 0;
                $scope.includeOrExcludeDM = null;
            }
            _.map(devicesData, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }
        else if ($scope.inputType == 'geo-location') {
            $scope.selectedGeoLocations.selLocationPickers = [];
            geoLocationsCount = 0;
            $scope.includeOrExcludeLocation = null;
            _.map($scope.locations, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }
        else if ($scope.inputType == 'connection') {
            if (type == "bandwidth") {
                $scope.selectedConnections.bandwidths = [];
                bandwidthCount = 0;
                $scope.includeOrExcludeBandwidth = null;
            }
            else if (type == "mobileCarrier") {
                $scope.selectedConnections.mobileCarriers = [];
                mobileCarrierCount = 0;
                $scope.includeOrExcludeMobile = null;
            }
            _.map(devicesData, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }
        else if ($scope.inputType == 'dfp_ad_units'){
            $scope.selectedAdUnits = [];
            $scope.adUnitsIncluded = [];
            $scope.adUnitsExcluded = [];
            _.map($scope.adUnitsList, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
                $scope.clearSelectedChildNodes(item);
                $scope.setChlidDataDefaultCreteria(item);
            });
        }
        else if($scope.inputType == "device-capability"){
            $scope.selectedData =[];
            $scope.includeOrExcludeCategory = null;
            $scope.capabilitiesIncluded =[];
            $scope.capabilitiesExcluded = [];
            _.map(devicesData, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }
        else if($scope.inputType == "DFP"){
            $scope.sets = [[]];
            $scope.keyValueBind =[];
        }
    }

    var processCategories = function (totalList, subList) {
        _.each(totalList, function (category) {
            _.each(subList, function (device) {
                if (device.id == category.id) {
                    category.criteria = device.criteria;
                    category.criteria_link = device.criteria_link;
                }
            })
        })
    }

    $scope.getConnectionsByContentKey = function () {
        _.each($scope.contentKeys, function (contentKey) {
            PackagesService.getlookupcontents(contentKey).then(function (success) {
                if (success.data && success.data.lookupContents && success.data.lookupContents.length > 0) {
                    _.each(success.data.lookupContents, function (content) {
                        var connection = {};
                        connection.id = content.id;
                        connection.name = content.lookup_value;
                        connection.criteria = "";
                        connection.criteria_link = "include";
                        if (contentKey === 'dfp_bandwidth_groups') {
                            $scope.bandwidths.push(connection);
                        } else if (contentKey === 'dfp_mobile_carriers') {
                            $scope.mobileCarriers.push(connection);
                        }
                    })
                    if ($scope.selectedConnections) {
                        var connectionList = [];
                        var subList = [];

                        if (($scope.selectedConnections.bandwidths && $scope.selectedConnections.bandwidths.length > 0) || ($scope.selectedConnections.mobileCarriers && $scope.selectedConnections.mobileCarriers.length > 0)) {
                            if (contentKey === 'dfp_bandwidth_groups') {
                                connectionList = $scope.bandwidths;
                                subList = $scope.selectedConnections.bandwidths;
                                if (subList && subList.length > 0) {
                                    $scope.includeOrExcludeBandwidth = subList[0].criteria + 'bandwidth';
                                }
                            } else if (contentKey === 'dfp_mobile_carriers') {
                                connectionList = $scope.mobileCarriers;
                                subList = $scope.selectedConnections.mobileCarriers;
                                if (subList && subList.length > 0) {
                                    $scope.includeOrExcludeMobile = subList[0].criteria + 'carrier';
                                }
                            }
                            processConnections(connectionList, subList);
                        }
                    }
                }
            }, function (error) { });
        })
    }

    var processConnections = function (totalList, subList) {
        _.each(totalList, function (connection) {
            _.each(subList, function (subConnection) {
                if (subConnection.id == connection.id) {
                    connection.criteria = subConnection.criteria;
                    connection.criteria_link = subConnection.criteria_link;
                }
            })
        })
    }

    $scope.setChlidDataCreteriaExclude = function (item) {
        if (item.childData && item.childData.length > 0) {
            item.childData.forEach(element => {
                element.showExclude = false;
                element.showInclude = false;
                if (element.childData && element.childData.length > 0) {
                    $scope.setChlidDataCreteriaExclude(element);
                }
            });
        }
    };

    $scope.setChlidDataCreteriaInclude = function (item) {
        if (item.childData && item.childData.length > 0) {
            item.childData.forEach(element => {
                element.showExclude = true;
                element.showInclude = false;
                if (element.childData && element.childData.length > 0 && element.criteria_link != 'excluded') {
                    $scope.setChlidDataCreteriaInclude(element);
                }
            });
        }
    };

    $scope.setChlidDataDefaultCreteria = function (item) {
        if (item.childData && item.childData.length > 0) {
            item.childData.forEach(element => {
                if(element.criteria_link == 'excluded' && element.childData && element.childData.length > 0){
                    element.showInclude = true;
                    $scope.setChlidDataCreteriaExclude(element);
                } else{
                    element.showExclude = true;
                    element.showInclude = true;
                    if (element.childData && element.childData.length > 0) {
                        $scope.setChlidDataDefaultCreteria(element);
                    }
                }
            });
        }
    };

    $scope.removeChildNodesCriteria = function (item) {
        if (item.childData && item.childData.length > 0) {
            _.each(item.childData, function (el) {
                var selIndex =  _.findIndex($scope.selectedAdUnits, { valueId: el.valueId });
                if (selIndex >= 0) {
                    $scope.selectedAdUnits.splice(selIndex, 1);
                    var itemIndex;
                    if (el.criteria == 'include') {
                        itemIndex = $scope.adUnitsIncluded.indexOf(el);
                        $scope.adUnitsIncluded.splice(itemIndex, 1);
                    }
                    else {
                        itemIndex = $scope.adUnitsExcluded.indexOf(el);
                        $scope.adUnitsExcluded.splice(itemIndex, 1);
                    }
                    el.criteria = '';
                    el.criteria_link = 'include';
                }
                $scope.removeChildNodesCriteria(el)
            })
        }

    };

    $scope.removeIncludedChildNodes = function (item) {
        if (item.childData && item.childData.length > 0) {
            _.each(item.childData, function (el) {
                if (el.criteria_link == 'included') {
                    var selIndex = $scope.selectedAdUnits.indexOf(el);
                    if (selIndex >= 0) {
                        $scope.selectedAdUnits.splice(selIndex, 1);
                        var itemIndex = $scope.adUnitsIncluded.indexOf(el);
                        $scope.adUnitsIncluded.splice(itemIndex, 1);
                        el.criteria = '';
                        el.criteria_link = 'include';
                    }
                }
                $scope.removeIncludedChildNodes(el);
            })
        }
    };

    $scope.saveWidgetValues = function () {
        if ($scope.inputType == "device-capability") {
            data.field_values = { deviceCapabilities: $scope.selectedData };
            data.field_values = JSON.stringify(data.field_values);
        }
        else if ($scope.inputType == "devices") {
            var selectedDevices = {
                deviceCategories: $scope.selectedDeviceCategories,
                browsers: $scope.selectedBrowsers,
                browserLanguages: $scope.selectedLanguages,
                deviceManufacturers: $scope.selectedDeviceManufacturers,
                operatingSystems: $scope.selectedOperatingSystems
            };
            data.field_values = selectedDevices;
            data.field_values = JSON.stringify(data.field_values);
        }
        else if ($scope.inputType == 'geo-location') {
            data.field_values = $scope.selectedGeoLocations;
            data.field_values = JSON.stringify(data.field_values);
        }
        else if ($scope.inputType == 'dfp_ad_units') {
            data.field_values = $scope.selectedAdUnits;
            var selectedData = [];
            _.each($scope.selectedAdUnits,function(item){
                var adunit ={};
                adunit.criteria = item.criteria;
                adunit.criteria_link = item.criteria_link;
                adunit.name = item.name;
                adunit.parentId = item.parentId;
                adunit.valueId = item.valueId;
                adunit.superParentId = item.superParentId;
                selectedData.push(adunit);
            });
            data.field_values = JSON.stringify(selectedData);
        }
        else if ($scope.inputType == 'connection') {
            data.field_values = $scope.selectedConnections;
            data.field_values = JSON.stringify(data.field_values);
        }
        else if($scope.inputType == 'DFP') {
            data.field_values = $scope.sets;
            data.field_values = JSON.stringify(data.field_values);
        }
        else if($scope.inputType == 'dfp-frequency'){
            data.field_values = $scope.frequencySets;
            data.field_values = JSON.stringify(data.field_values);
        }
        $modalInstance.dismiss();
    }

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };
    $scope.init();
}

HelperTextController.$inject = ['$scope', '$modalInstance'];

function HelperTextController($scope, $modalInstance) {
    $scope.cancel = function(){
        $modalInstance.dismiss()
    }
}

GetBulkKeywordsController.$inject = ['$scope', '$modalInstance', 'data', 'FormService'];
function GetBulkKeywordsController($scope, $modalInstance, data, FormService) {
    $scope.type = 'getBulkKeywords';
    $scope.title = "Keywords";
    $scope.clientId = data.clientId;
    $scope.keywords = [];
    $scope.rowsOfKeywords = [];
    $scope.setText = function(text) {
        $scope.text = text;
        $scope.pageUrl = null;
    };
    $scope.setPageUrl = function(pageUrl) {
        $scope.pageUrl = pageUrl;
        $scope.text = null;
    };
    $scope.getKeywords = function() {
        $scope.keywords = [];
        $scope.rowsOfKeywords = [];
        FormService.getKeywordsForAdwords($scope.text, $scope.pageUrl, $scope.clientId).then(function (success) {
            if (success && success.keywords && success.keywords.length > 0) {
                $scope.keywords = success.keywords; // Needed as is to import into widget
                // Format in rows of two columns for display inside the modal textarea.
                let onFirstItem = true;
                let currentRow = undefined;
                _.each($scope.keywords, function(item) {
                    if (onFirstItem) {
                        currentRow = {};
                        currentRow.item1 = item;
                        currentRow.item2 = ''; // In case we never get to it in the next iteration.
                    } else {
                        currentRow.item2 = item;
                        $scope.rowsOfKeywords.push(currentRow);
                    }
                    onFirstItem = !onFirstItem;
                });
                if (!onFirstItem) {
                    $scope.rowsOfKeywords.push(currentRow);
                }
            }
        }, function () {
            console.log("Error, could not fetch keywords");
        });
    };
    $scope.ok = function() {
        $modalInstance.close($scope.keywords);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

AssignPlacementsController.$inject = ['$scope','$modalInstance', 'data'];

function AssignPlacementsController($scope, $modalInstance, data) {
    $scope.type = 'assignPlacements';

    $scope.checkedLineItemIds = data.checkedLineItemIds;
    $scope.checkedFlightIds = data.checkedFlightIds;
    $scope.targetLineItemId = data.targetLineItemId;

    $scope.ok = function() {
        $modalInstance.close();
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}

/**
 * @ngInject
 */
function UnprocessableEntityModalController($modalInstance, data) {
    let vm = this

    vm.errors = data ? data : []

    vm.ok = function () {
        $modalInstance.dismiss()
    }
}